/* eslint-disable sort-keys, max-len, no-template-curly-in-string */
export default {
    '?': '?',
    main: {
        auctionCentralNews: 'Auction Central News',
        auctionResultsDatabase: 'Auction Results Database',
        consignmentsHub: 'LiveAuctioneers Consignment Hub',
    },

    liveAuctionBar: {
        button: 'Trending Live',
        more: 'More',
    },

    header: {
        j52: 'Weekly Auctions of Exceptional Items',
    },

    // components
    acceptedCards: {
        text: 'We accept the following cards:',
    },
    bidLimitExceededMessage: {
        linkText: 'sending a message',
        subject: 'Bid limits',
        text:
            '{sellerName} sets the maximum you can bid when you register.  If you are interested in bidding more, please reach out to {sellerName} by {link} or calling {sellerPhone}',
    },
    buyNowSummary: {
        buyersPremium: "Buyer's Premium:",
        itemPrice: 'Item Price:',
        quotePending: 'Quote Pending',
        shipping: 'Shipping:',
        total: 'Total:',
        totalPlusShipping: '{total} + Shipping',
    },
    creditCardForm: {
        submit: 'Save my card',
    },
    forgotPassword: {
        emailAddress: 'Email Address',
        error: 'Please enter a valid email address.',
        sendResetLinkToSMS: 'Also send the reset link to my phone number on file',
        submit: 'Send Reset Instructions',
    },
    forgotPasswordConfirmation: {
        help:
            'If you haven’t received an email within a few minutes, check your spam folder. You can also {link} once every five minutes. Only the most recent reset email will work.',
        helpLink: 'resend the email',
        text: 'We sent you an email with instructions on how to reset your password.',
    },
    itemBidding: {
        bid: 'bid',
        bids: 'bids',
        lotsAway_short: '{lotsAway} Lots Away',
        lotAway_short: '1 Lot Away',
        estimate: 'Estimate {low} - {high}',
        passedText: 'Lot Passed',
        lotAgo: 'Closed 1 Lot Ago',
        lotsAgo: 'Closed {lots} Lots Ago',
        lotAway: 'Get Ready! 1 Lot Away',
        lotsAway: 'Coming Up: {lots} Lots Away',
        liveNow: 'Live Now',
        soldText: 'Sold for {amount}',
        leftToBid: 'Only {count} seconds left to bid!',
        dontWait:
            "Don't wait until the last second to bid!  To give all bidders a fair chance at winning, bidding is extended when additional bids are placed in the final moments of the auction.",
    },
    paymentProcessedNotification: {
        shipping: {
            cta: 'Pay for shipping',
            description: 'Payment is required to schedule collection.',
            header: 'Book Your Shipment with ARTA',
        },
        title: 'Checkout Confirmation - LiveAuctioneers',
        description: '',
        header: 'Thank you! We processed your payment.',
        message:
            "We sent you an email with your order confirmation and receipt. If you haven't arranged shipping yet, please contact your preferred shipping company or {house}.",
    },
    shippingDetails: {
        inquireInternational: 'Ask for international & combined shipping rates',
        shippingToUS: '{domesticShippingCost} shipping to contiguous United States',
        shipsFromAgent: 'Ships from verified Jasper52 seller #{agentId}',
        shipsFromAgentIn: 'Ships from verified Jasper52 seller #{agentId} in {fromLocation}',
        freeConUS: 'Free {stateCode}',
    },
    // Item page, lower right shipping section
    shippingInfo: {
        shippingPoliciesModalTitle: 'Shipping, Payment & Auction Policies',
        sectionHeader: 'Shipping, Payment & Auction Policies',
        shipsFromLabel: 'Ships from',
        shipsFromJasper52: 'Jasper52 seller #{agentId} in {location}',
        shippingLocation: '{city}, {state}, {country}',
        shippingLocationNoState: '{city}, {country}',
        sellerLink: 'Shop all from this seller',
        viewPoliciesLink: 'View Shipping, Payment & Auction Policies',
        announcement: {
            announcementFrom: 'Announcement from {sellerName}',
            read: 'Read Auctioneer Announcement',
        },
        localPickup: {
            localPickupLabel: 'Free Local Pick-Up',
            localPickupNotAvailableLabel: 'Pick-Up Not Available',
        },
        shippingCost: {
            freeShipping: 'Free Shipping',
            freeShippingToContiguousUS: 'Free Shipping to Contiguous US',
            flatRate: 'Flat-Rate Shipping',
            flatRateShippingToContiguousUS: 'Flat-Rate Shipping to Contiguous US',
            getShippingQuote: 'Get Shipping Quote',
            shippingQuote: 'Shipping',
            buyerArrangesShipping: 'Buyer Arranges Shipping',
            seePolicyForShipping: 'See Policy for Shipping',
            ratesVaryByDestination: 'Rates Vary by Destination',
            offersInHouseShipping: 'Offers In-House Shipping',
            infoPopoverText: 'See policy for additional info and suggested shippers.',
            infoPopoverLink: 'Learn More',
            unable: 'Quote Unavailable',
        },
        shippingTo: {
            toContiguousUS: 'to contiguous US',
            toUSZip: 'to US, {zip}',
            shippingToLine: 'Shipping to {countryCode}, {zip}',
            shippingToLineWOCountryCode: 'Shipping to, {zip}',
            changeZipButton: 'Change',
        },
        shippingEstimateForm: {
            enterZipUS: 'Enter a ZIP code for shipping info.',
            enterZipNonUS: 'Enter a postal code for shipping info.',
            zipInputLabel: 'Shipping to:',
            zipInputErrorUS: 'Enter a valid ZIP code.',
            zipInputErrorNonUS: 'Enter a valid postal code.',
            zipInputPlaceholderUS: 'ZIP',
            zipInputPlaceholderNonUS: 'Postal Code',
            applyZipButton: 'Apply',
        },
    },

    // item page terms & info
    itemTerms: {
        hasWeapons: 'Credit card payments are not accepted for firearms through LiveAuctioneers, no exceptions.',
    },

    terms_modal: {
        cta: 'Back to Checkout',
    },

    taxExemptModal: {
        title: 'Tax-Exempt?',
        subtitle:
            'As a reseller, you’re eligible for tax exemption. It can take a couple days for your certificate to process, so make sure to add it to your account page as soon as possible.',
        upload: 'Upload Certificate',
        notExempt: "Doesn't Apply",
        notSure: 'Not sure if you qualify? {link}',
        learn: 'Learn more.',
    },

    itemPageFirstTimeModal: {
        huntingFor: 'Hunting for',
        onTheHunt: 'On the hunt?',
        subtitle:
            'As a reseller, you’re eligible for tax exemption. It can take a couple days for your certificate to process, so make sure to add it to your account page as soon as possible.',
        upload: 'Upload Certificate',
        notExempt: "I'm not tax-exempt",
        notSure: 'Not sure if you qualify? {link}',
        learn: 'Learn more.',
        enterEmailBelow: 'Enter your email below to get alerts when more items like this are listed.',
    },

    // forms
    formErrors: {
        accountNumberEmpty: 'Please enter at least 5 digits.',
        accountNumberLength: 'Account number cannot exceed 20 digits.',
        addressEmpty: 'Enter an address.',
        bankNicknameEmpty: 'Enter an account nickname',
        cardNumberEmpty: 'Enter a valid credit card number.',
        cardNumberInvalid: 'Enter a valid credit card number.',
        cityEmpty: 'Enter a city.',
        countryEmpty: 'Country cannot be empty.',
        cvcCodeEmpty: 'Enter a valid security code.',
        cvcCodeInvalid: 'Enter a valid security code.',
        emailEmpty: 'Enter a valid email address.',
        emailInvalid: 'Enter a valid email address.',
        expirationDateInvalid: 'Enter a valid expiration date.',
        expirationMonthEmpty: 'Enter a valid month.',
        expirationMonthInvalid: 'Enter a valid month.',
        expirationYearEmpty: 'Enter a valid year.',
        firstNameEmpty: 'Enter a first name.',
        lastNameEmpty: 'Enter a last name.',
        mobileNumberEmpty: 'Enter a mobile phone number.',
        nameEmpty: 'Enter a name.',
        none: '',
        offerEmpty: 'Enter a valid offer.',
        offerInvalid: 'Enter a valid offer.',
        passwordConfirmMatch: 'Passwords must match.',
        passwordEmpty: 'Password cannot be empty.',
        passwordLength: 'Password must be greater than 6 characters.',
        routingNumberInvalid: 'Please enter a 9-digit routing number.',
        stateEmpty: 'Enter a state.',
        zipEmpty: 'Enter a ZIP/postal code.',
    },
    formLabels: {
        accountNumber: 'Account Number',
        address: 'Address',
        address2: 'Address 2',
        bankAccountName: 'Bank Nickname',
        card: 'Card',
        cardNumberPlaceholder: 'Card number',
        city: 'City',
        confirmNewPassword: 'Confirm new password',
        country: 'Country',
        cvcCode: 'Security code',
        cvcPlaceholder: 'CVC',
        email: 'Email',
        exp: 'Exp.',
        expirationDate: 'Expiration date',
        expirationMonth: 'Expiration date',
        expirationYear: 'Expiration year',
        firstName: 'First name',
        cardholderNamePlaceholder: 'Full name',
        lastName: 'Last name',
        message: 'Message',
        messageOptional: 'Include Message',
        mmyyPlaceholder: 'MM/YY',
        mobileNumber: 'Mobile Phone Number',
        nameOnCard: 'Name on Card',
        newPassword: 'New password',
        offer: 'Your Offer',
        optional_parenthesis: '(optional)',
        postalCode: 'Postal Code',
        routingNumber: 'Routing Number',
        state: 'State',
        zip: 'Zip/Postal Code',
    },

    // modals
    smsConfirmationModal: {
        TOSTitle: 'SMS Terms of Service',
        SMSNotice_1:
            "You'll receive messages when you're outbid and when your item is coming up for auction. Messages and data rates may apply. ",
        SMSNotice_2: 'Reply STOP to end.',
    },
    absenteeBidModal: {
        smsFooter: {
            title_unconfirmed: 'Never miss a treasure with SMS alerts.',
            title_confirmed: "You've activated SMS alerts!",
            body: 'Get texts when outbid and item up for auction. Msg & data rates may vary. Reply STOP to end.',
            label: 'I accept the {tocLink}.',
            cta: 'Receive SMS',
            confirm: {
                title: 'SMS alerts are enabled!',
                title2: "We'll send alerts to {phoneNumber}",
                manage: 'Manage Alerts',
            },
        },
    },
    addBankAccountModal: {
        error: 'There was an error adding your bank account.',
        header: 'Add Bank Information',
        success: 'Bank account added successfully',
        returnToProfile: 'Return to profile',
    },
    addCreditCardModal: {
        error: 'There was an error adding your credit card.',
        footer: 'Note: Your card will not be charged at this time.',
        header: 'Get approved faster with a card on file',
        success: 'Credit card added successfully',
        returnToProfile: 'Return to profile',
    },
    bidLimitExceededModal: {
        header: 'What is a bid limit?',
    },
    completeAccountModal: {
        address: 'Address',
        address1: 'Address 1',
        address2: 'Address 2',
        city: 'city',
        country: 'country',
        firstName: 'first name',
        header: 'One last thing!',
        inputError: 'Enter a {token}.',
        inputError2: 'Choose a {token}.',
        inputInvalid: 'Enter a valid {token}.',
        lastName: 'last name',
        mobilePhone: 'mobile phone number',
        optional: '(optional)',
        state: 'state/province',
        subHeader: 'Complete your profile to start bidding.',
        submit: 'SAVE PROFILE',
        zipCode: 'zip/postal code',
    },
    followSearchModal: {
        emailAddress: 'Email Address',
        emailMeNewItems: 'Email Me New Items',
        startNow: 'Start Now',
    },
    forgotPasswordModal: {
        header: 'Please enter your email below.',
        header2: 'Check your email.',
        subHeader: "We'll send you a link to reset your password.",
    },
    loginModal: {
        error: 'Your username or password is incorrect.',
        errorAlreadyExists: "You're already registered. Log in below:",
        footer: "Don't have an account?",
        footerLink: 'Join',
        forgot: 'Forgot Password?',
        header: 'Log in to begin your treasure hunt.',
        hide: 'hide',
        password: 'password',
        show: 'show',
        submit: 'Log In',
        username: 'EMAIL ADDRESS / USERNAME',
    },
    preferencesModal: {
        title: 'What are you hunting for?',
        subtitle: 'Pick 4 or more',
        cta: {
            pick: 'Pick {count} more',
            continue: 'Continue',
        },
    },
    setPasswordModal: {
        footer: 'Already have an account? {link}',
        footerLink: 'Log In',
        header: "Yes! Finish creating your account to join the world's largest treasure hunt.",
        hide: 'hide',
        invalidPassword: 'Your password must be at least 6 characters.',
        password: 'password',
        show: 'show',
        submit: 'Join',
        username: 'Email Address',
        passwordStrength: 'Password Strength:',
        newPasswordStrength: 'New Password Strength:',
        weak: 'Weak',
        strong: 'Strong',
        characterLimit: '7 or more characters',
        upperAndLower: 'Upper & lowercase characters',
        specialCharacters: 'At least one number or special character',
        avoidPasswords: 'Avoid passwords that are easy to guess or used with other websites.',
    },
    sharedModal: {
        footer: 'Have a general question?',
        footerJ52: 'Have a question about Jasper52?',
        footerLink: 'Get Answers Here',
    },
    signUpModal: {
        acceptText: 'I accept the {tosLink}, {privacyLink}, and {cookieLink}.',
        cookieLink: 'Cookie Policy',
        error: "Sorry, we've experienced a server error.",
        footer: 'Already have an account? {link}',
        footerLink: 'Log In',
        header: 'Sign up and begin your treasure hunt.',
        invalidEmail: 'Please enter a valid email address.',
        privacyLink: 'Privacy Policy',
        submit: 'START NOW',
        termsError: 'Please accept terms & conditions to continue.',
        termsLink: 'Terms',
        username: 'Email Address',
        worth: "What's It Worth?",
        access: 'Sign up to access 50 million price results, always free.',
        followAuctioneer: 'Follow This Auctioneer',
        getAlerts: 'Get alerts when {name} lists new auctions.',
        getApproved: 'Get Approved to Bid',
        registerApprove: 'Sign up to register for this auction and get approved to bid.',
        love: 'Love This Item?',
        track: 'Sign up to track your favorite items.',
        ready: 'Get Ready to Bid!',
        placeBid: 'Sign up to place your bid and win. ',
        question: 'Have a Question?',
        sendQuestion: 'Sign up to send a question to the auctioneer.',
        followSearch: 'Follow This Search',
        getSearchAlerts: 'Get alerts when new {name} items are listed.',
    },
    waitingOnApprovalModal: {
        title: 'Still waiting on approval?',
        reasonConsole:
            'Please allow a few minutes for your request to be approved. Auction registrations are reviewed and approved to ensure a fair auction with vetted bidders, getting you the best possible prices.',
        reason1: 'Auctioneers typically take at least a few minutes to review and approve new bidders',
        reason1NonUrgent:
            'Auction registrations are reviewed and approved to ensure a fair auction with vetted bidders, getting you the best possible prices.',
        reason2:
            'This auction house takes their time approving bidders to protect you from fraudulent bids, getting you the best price',
        subheading: 'What you can do:',
        whatyoucando1: 'Including {link}, address, and contact information typically helps get approval faster',
        whatyoucandoConsole1:
            'Auction houses have varying processes for conducting auction approvals. For the best chances of getting approved quickly, {creditCardInfo} and make sure {link} is up-to-date.',
        whatyoucando1NonUrgent:
            'Auction houses have varying processes for conducting auction approvals. For the best chances of getting approved quickly, {link}, and make sure your profile is up-to-date.',
        whatyoucando1Update: 'complete credit card information in your account profile',
        whatyoucandoConsole1Update1: 'complete your credit card information',
        whatyoucandoConsole1Update2: 'your profile',
        whatyoucando1UpdateNonUrgent: 'complete your credit card information',
        whatyoucando2: 'If you’re not approved soon, {link} to request approval',
        whatyoucandoConsole2:
            "If you're not approved soon, or if you'd like to place a live bid on an upcoming lot, contact the auctioneer at {phoneNumber}",
        whatyoucando2NonUrgent:
            'Typically auction approvals are conducted within 48 hours. If you haven’t heard from the auction house, or if the auction starts in less than 48 hours, {link} to request approval.',
        whatyoucando2Send: 'send them a message',
        whatyoucando2SendNonUrgent: 'send the auctioneer a message',
        whatyoucando3: 'Contact this auction house at {phoneNumber}',
        sellerSubject: 'Approval waiting for {fullName} on catalog "{title}"',
        edit: 'Edit Profile',
        reminder: 'Send Reminder',
    },
    registrationModal: {
        titles: {
            addCardOnFile: 'Get approved faster with a card on file',
            addCardOnFile_short: 'Get approved faster!',
            addCreditCard: 'Add Credit Card',
            addPayment: 'Add Payment',
            completeRegistration: 'Complete Registration',
            confirmPayment: 'Confirm Payment Method',
            thanks: 'Thanks, {firstName}',
            updateAddress: 'Billing address',
            updateCardOnFile: 'Update Card on File',
        },
        subtitles: {
            completeRegistrationShort: 'Get ready to bid {firstName}! Remember, all sales are final.',
            completeRegistrationFull:
                "You're welcome to place absentee bids while your auction registration is pending. Auction houses typically process auction registrations within 24 hours. An email notification will be sent to you once your registration has been reviewed.",
            thanks:
                "We will email you as soon as the auction house approves your registration. Don't forget to follow {auctionHouse} to get alerts when they list new auctions.",
            thanksAddCard: 'add a credit card',
            addCardOnFile:
                'This will help us verify your eligibility to bid and will give you a better chance of getting approved to bid, but your card will not be charged.',
            registrationPayment:
                'If you win, the auction house will follow up separately with their payment instructions.',
            updateCardOnFile:
                'Your existing card on file may be out of date. Adding a current card will help verify your eligibility to bid. Your card will not be changed now.',
        },
        confirmPayment: {
            cards: 'Card on file',
            change: 'Change',
            error: 'There was an error adding your credit card.',
        },
        termsAgree: "By selecting continue, I agree to {sellerName}'s {termsLink}.",
        termsAgreeSubmit: "By selecting submit, I agree to {sellerName}'s {termsLink}.",
        termsLink: 'Terms of Sale',
        notifyMe: 'Follow {sellerName}',
        cta: {
            continue: 'Continue',
            submit: 'Submit',
            submitRegistration: 'Submit Registration',
            done: 'Done',
            updateCardOnFile: 'Save and Continue',
        },
        skip: 'Skip for now',
        skipText: 'Adding your credit card will give you a better chance of getting approved to bid!',
    },
    clearCacheModal: {
        seeSafari: 'We see that you’re using Big Sur and Safari.',
        sometimesSafari:
            'Sometimes updating to a new MacOS in conjunction with a new Safari can cause browser slowness for some people.',
        cacheSafari:
            'If you are experiencing slowness, particularly in scrolling, please press [CMD] + [OPTION] + [E] to clear your browser caches.',
    },

    // pages
    termsPage: {
        title: 'Terms and Conditions: {title}',
    },
    aboutUs: {
        apply: 'apply to become an auctioneer',
        apps: "LiveAuctioneers' iPhone and Android apps",
        browse: 'browse curated auctions',
        content1:
            'LiveAuctioneers brings an international audience of millions to the heart of the bidding action in {art}, antiques, {jewelry} and {collectibles} auctions across the globe.',
        content2:
            "With fascinating objects up for bid in more than 50 countries—instantly translated to your language and currency—LiveAuctioneers is a worldwide marketplace with treasures waiting to be discovered, whether you're an avid collector or first-time visitor.",
        content3:
            "By hosting thousands of auctions in real time via the Internet, the site allows unprecedented access to remote sales, and savvy bidders can often land desired items at very desirable prices. Leave an absentee bid, or fully engage in the live-auction action—it's up to you. All bidding takes place via a secure bidder network, which keeps your maximum bids for upcoming sales private until the item is opened on the day of the sale.",
        content4:
            'LiveAuctioneers revolutionized the industry from the start. In 2002, the NYC-based company formed a marketing partnership with eBay to introduce eBay Live Auctions. This alliance of LiveAuctioneers and eBay enabled auction houses worldwide to go online with their live sales—a development that changed the auction business forever. In 2009, the debut of {apps}, with live-bidding capabilities, opened up a new mobile pipeline to bid anytime, from anywhere, with complete anonymity. Since then, LiveAuctioneers has been the first to engage bidders with live streaming video, easy online payments, personalized search alerts, and more.',
        content5:
            "Now in its second decade, LiveAuctioneers is the Web's leading auction-related site, with millions of qualified bidders. LiveAuctioneers also provides a constant stream of industry intelligence to auctioneers, collectors, museums, appraisers, consignors and more via:",
        content6:
            'The easy-to-use {auctionResults}, a vast database with more than 29 million results that offers keyword-search access to verified auction outcomes, recent to historical. The updated archive is the #1 free online resource for the trade, appraisers, collectors, designers, art institutions, estate officers, journalists, students and others on the research trail;',
        content7:
            '{auctionCentral}, the global destination for the latest auction headlines, mixing timely industry news with feature articles by experts on all things design;',
        content8:
            'The {consignmentsHub}, an easy way for interested consignors to share their property for review and evaluation with thousands of auction houses in one spot.',
        content9:
            'There are many ways to get started as a collector. You can {browse}, find {nearMe}, set up keyword search alerts, search, bid and win.',
        content10:
            'If you’re interested in selling online, {apply} or {share}. LiveAuctioneers’ award-winning {support} services are always available if you have questions.',
        description: 'Exceptional Items from Trusted\nAuction Houses',
        nearMe: 'auctions near you',
        popular: 'Popular Categories',
        share: 'share your consignment',
        support: 'customer support',
        title: 'About LiveAuctioneers',
    },
    accountSettings: {
        errorCodes: {
            INVALID_ROUTING_NUMBER: 'Please enter a valid routing number',
        },
        username: 'Username',
        delete: 'Delete Account',
        bankAccountOnFileLabel: 'Echeck (ach) Payment',
        eCheckPay: 'Easily pay with direct transfers via eCheck (ACH).',
        eCheckTitle: 'Easily Pay With eCheck',
        cardOnFileLabel: 'Card on file',
        highRiskCofLabel: 'Card on file for sensitive or regulated purchases',
        description: 'Change your account settings',
        title: 'Account Settings',
        addCardOnFileButton: 'Add Credit Card',
        addBank: 'Add Bank Information',
        payments: 'Payments',
        buttonText: {
            release: 'Release Deposit',
            pending: 'Processing',
            locked: 'Deposit Locked',
        },
        bankDetails: 'Add your bank details for direct transfers via eCheck (ACH).',
    },
    deleteAccountModal: {
        title: 'Confirm Account Deletion',
        subtitle:
            'I understand this means any data I may have created–including my bidding history, purchase records, and followed searches–will no longer be available.',
        error: 'There was an error deleting your account. {link}.',
        errorUnpaidDispute:
            'We could not close your account because you have unpaid items or disputes. Please review your {link} for more information. ',
        support: 'Please contact support',
        keep: 'Keep Account',
        delete: 'Delete',
    },
    notificationsPage: {
        title: 'Emails & Notifications',
        description: 'Update email and notification settings',
        missingNumber: 'Add a mobile phone number',
        unsubscribeAll: 'Turn off all notifications',
        disabled: 'Modify your browser preferences to proceed with enabling browser notifications.',
        section: {
            newsletters: 'Marketing Updates ({ count })',
            alerts: 'Auction Alerts ({ count })',
            searches: 'Followed Searches ({ count })',
            auctioneers: 'Followed Auctioneers ({ count })',
        },
        table: {
            header: {
                browserAlert: 'Browser',
                emailAlert: 'Email',
                frequency: 'Frequency',
                searchTerm: 'Search Term',
                smsAlert: 'SMS',
                type: 'Alert Type',
                lastNewResult: 'Last New Result',
            },
            descriptions: {
                '1':
                    'Receive an email notifying you if someone else bids on an item on which you have already placed a bid.',
                '2': 'Notifies you when an item you bid on or saved is almost up for auction.',
                '3': "Notifies you when you're approved or declined for auctions you registered for.",
                '4': "Get a reminder when items you've bid on are going live in the next couple days.",
                '5': 'A digest of newly listed auctions from auctioneers you follow.',
                '6': 'Receive an email asking you to rate and review your buying experience with auctioneers.',
            },
            frequency: {
                '1': 'Real-Time',
                '2': 'Real-Time',
                '3': 'Real-Time',
                '4': 'Daily (when you have bids)',
                '5': 'Every other day (if new auctions listed)',
                '6': 'Three weeks after winning',
            },
            managePreferencesRow: {
                title: 'Category Preferences',
                description:
                    'Receive a weekly digest about exclusive and exceptional auctions and items in your favorite categories.',
                frequency: 'Weekly',
                link: 'Manage',
            },
        },
    },
    addCreditCard: {
        description: 'Add a credit card',
        title: 'Add credit card',
    },
    passwordReset: {
        description: 'Reset your password',
        title: 'Reset Your Password',
        submit: 'Set new password',
        error: 'There was an error resetting your password.',
        errorIncorrectCode: 'The password reset code is incorrect.',
        errorResetCodeExpired: 'The password reset code has expired.',
        errorTryAgain: 'Click here to try again.',
        success: "You've successfully reset your password and logged in.",
        returnHome: 'Continue to LiveAuctioneers',
        confirmNewPassword: 'Confirm New Password',
        newPassword: 'New Password',
    },
    flattenTheCurve: {
        description: 'Bid on LiveAuctioneers and fight the spread of COVID-19',
        title: 'Flatten the Curve - COVID-19 Response Support',
    },

    // Head Data
    get_in_on_the_auction:
        "World's Largest Art, Antiques & Collectibles Online Marketplace. 280,000+ items for online auction from 5,000+ auctioneers. Research 50 million+ auction price results.",
    seller_review_meta:
        "Read Seller Reviews of LiveAuctioneers. World's Largest Art, Antiques & Collectibles Online Marketplace. 280,000+ items for online auction from 5,000+ auctioneers.",
    bid_in_online_auctions: 'LiveAuctioneers: Bid in Online Auctions & Research Auction Results',

    // Header
    lot_number: 'Lot Number',
    lot_number_short: 'Lot #',
    starting_bid: 'Starting Price',
    auctioneer: 'Auctioneer',
    auction: 'Auction',
    date: 'Date',

    // Crown
    directory: 'Directory',
    price_results: 'Price Results',
    news: 'News',
    help: 'Help',
    consign: 'Consign',

    // Outdated Browser Modal
    did_you_know_that_your_web_browser:
        "Did you know that your web browser is a little outdated? You're using {formalName} version {majorVersion}.",
    browsers_for_best_experience:
        'For the best LiveAuctioneers experience, please upgrade to a newer version of {chrome}, {firefox}, or {edge}.',
    chrome: 'Google Chrome',
    edge: 'Microsoft Edge',
    firefox: 'Mozilla Firefox',
    ie: 'Internet Explorer',
    safari: 'Apple Safari',

    // Search
    search_placeholder: 'Search for items and auction houses',
    log_in: 'Log In',
    log_out: 'Log Out',
    sign_up: 'Join',
    me: 'me',
    my_bids: 'My Bids',
    my_auctions: 'My Auctions',
    won_items: 'Won Items',
    messages: 'Messages',
    saved_searches_and_alerts: 'Followed Searches and Alerts',
    followed_auctioneers: 'Followed Auctioneers',
    followed_searches: 'Followed Searches',
    account_settings: 'Account Settings',
    auction_houses: 'Auction Houses',
    auction_price_results: 'Auction Price Results',
    deleted_item_1: 'is no longer available.',
    deleted_item_2: 'Create a search alert',
    deleted_item_3: 'or find similar items below.',
    auction_total: 'Upcoming ({total})',
    price_results_total: 'Price Results ({total})',
    searchPage: {
        mobileHeader: {
            title: 'Filter',
            subtitle: '{items} items',
        },
        mobileFooter: {
            clear: 'Clear Filters',
        },
    },
    auctionNews: {
        newsAboutTitle: 'News about',
    },
    categoryCatalogs: {
        title: ' Auctions',
    },

    favorites: {
        title: 'Favorites',
        itemsTab: 'Items',
        searchesTab: 'Searches',
        auctioneersTab: 'Auctioneers',
        manage: 'Manage Followed Searches',
        followNewSearch: 'Follow New Search',
    },
    manageNotifications: 'Manage Notifications',

    // Navigation
    navigation: {
        today: 'Trending',
        art: 'Art',
        categories: 'Categories',
        jewelry: 'Jewelry',
        asian_antiques: 'Asian Antiques',
        furniture: 'Furniture',
        collectibles: 'Collectibles',
        home_and_garden: 'Home & Décor',
        fashion: 'Fashion',
        memorabilia: 'Memorabilia',
        coins: 'Coins',
    },

    // Home
    home: 'Home',
    online_auctions: 'Online Auctions',
    home_title: 'LiveAuctioneers: Bid in Online Auctions & Research Auction Results',
    exceptional_items_from_trusted_auction_houses: 'Exceptional Items from Trusted\nAuction Houses',
    consignments_description:
        "LiveAuctioneers' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help make that key connection to our more than 5,000+ auctioneers.",
    items_auctioned: 'Items Auctioned',
    in_secure_bids: 'In Secure Bids',
    items_available: 'Items Available',
    licensed_auction_experts: 'Licensed Auction Experts',
    bidding_steps: '4 Easy Steps to Start Bidding',
    browse_by_category: 'Staff Curated Collections',
    featured_auctions: 'Featured Auctions',
    trending_items: 'Trending Items',
    upcoming_auctions_live_count: '{liveCount} Live & Upcoming Auctions',
    upcoming_items: '{liveCount} Upcoming Items',
    past_items: 'See All {pastCount} Past Auctions',
    become_title: 'Become a Member',
    become_text: 'Join the community with the largest collection of storied objects.',
    browse_title: 'Browse',
    browse_text: 'Discover new treasures with our robust search feature or explore by category.',
    bid_title: 'Bid Anytime',
    bid_text: 'Enter an amount and place bids online anytime before an auction begins.',
    pay_title: 'Pay Only If You Win',
    pay_text: 'Complete your transaction only after you bid and win. Items are then delivered to your door.',
    explore: 'Explore',
    live_auction: 'Bid Now',
    live: 'Live',
    paused: 'Paused',
    liveauctioneers: 'LiveAuctioneers',
    sitemap: 'Sitemap',
    see_all: 'See All',
    auctioneer_directory: 'Auctioneer Directory',
    auction_previews: 'Auction Previews',
    auction_results: 'Auction Results',
    be_informed: 'Be Informed',
    top_news: 'Top News',
    auctions_you_may_like: 'Auctions You May Like',

    auctions_within_miles: 'Auctions within {distance} of {zipCode}',
    distance_miles: '{distance} Miles',
    local_auctions_are_great:
        'Local auctions are great for cheaper shipping, and the option to preview items in person',

    // Live Items
    bid_live: 'Bid Live',
    bids: 'Bids',
    oneBid: '1 bid',
    bids_with_count: '{numberOfBids} bid{s}',
    saves_with_count: '{numberOfSaves} save{s}',
    lot_passed_not_disclosed: 'Lot Passed',
    lot_unsold: 'Lot not sold but might reopen',
    select_maximum_bid: 'Your Maximum Bid:',
    select_create_bid_option: 'Bid {amount}',
    increase_your_maximum_bid: 'Increase Your Maximum Bid ({amount}):',
    place_bid: 'Place Bid',
    secure_bidding: 'Secure',
    estimate: 'Estimate',
    estimate_values: 'Estimate {low} - {high}',
    short_estimate: 'Est.',
    short_estimate_value: 'Est. {number}',
    short_estimate_values: 'Est. {low}-{high}',
    short_estimate_values_print: 'Est. {low} - {high}',
    save_item: 'Save Item',
    unsave_item: 'Unsave Item',
    item_saved: 'Item Saved',
    interested_in_this_item: 'Interested in this item?',
    register_for_auction: 'Register for Auction',
    save_to_saved_items: "Save to 'Saved Items' to access later.",
    registration_declined: 'Registration Declined',
    account_suspended: 'Account Suspended',
    help_center: 'Help Center',
    auctioneer_has_declined_registration: 'The auctioneer has declined your registration.',
    registration_pending: 'Registration Pending',
    registration_approved: 'Registration Approved',
    download_our_app: 'Download Our App',
    and_get_bid_notifications: '& get bid notifications',
    lot_number_from: 'Lot {lotNumber} from',
    unregistered_message:
        "You'll have to register before you can place bids in this auction. This auction has already started, so you might want to hurry!",
    you_are_the_leading_bidder: 'You are the leading bidder!',
    you_have_been_outbid: 'You have been outbid!',
    increase_your_chances: 'Increase your chances of winning by bidding higher.',
    increase_bid: 'Increase bid',
    bid_in_the_live_auction: 'Bid in the live auction for the best chance of winning.',
    why_cant_i_place_absentee_bid: "Why can't I place an absentee bid?",
    why_cant_i_place_absentee_bid_popover_text:
        'Absentee bids cannot be placed on items after the auction has started. Enter the live auction to bid on the item.',
    why_cant_i_retract_bid_popover_text: 'Bids may not be retracted after an auction has started.',
    item_lot_number: 'Lot {lotNumber}',
    search_items_helper: 'Lot # or Lot Title',
    request_online_bidding: 'Request online auction',
    register_partners_site: 'Register on Partner Site',
    visit_partners_site: 'Visit Partner Site',
    register_partners_site_warning: 'Clicking this link will redirect you to our partner’s website.',
    online_bidding_requested: 'Online bidding requested',
    no_bid_reason:
        "Online bidding isn't available for this catalog. To request online bidding {link} and you’ll be notified if bidding is made available.",
    request_submitted: 'Request submitted',
    request_submitted_long: "We'll send you an email if the catalog begins accepting bids.",
    click_here: 'click here',

    toastMessage: 'This item is accepting live bids! Place your live bid below to win.',

    // Ended Items
    ask_auctioneer: 'Ask Auctioneer',
    sell_similar_item: 'Sell a Similar Item',
    show_bid_history: 'Show Remaining Bid History',
    hide_bid_history: 'Hide Bid History',
    my_bid: 'My bid',
    bidder: 'Bidder',
    bid_history: 'Bid History',
    view_bid_history: 'View Bid history',
    lot_passed: 'Lot Passed',
    lot_unsold_pending: 'Lot Pending',
    starting_bid_lot_passed: 'Starting Bid {amount}',
    auction_ended_on: 'Auction ended on {date}',
    see_more_items: 'See More Items',
    view_details: 'view details',
    dont_miss_next: "Don't Miss Your Next Treasure.",
    set_up_search_alert: 'Set up a search alert to hear when {sellerName} lists new auctions.',
    set_up_item_search_alert: 'Set up a search alert to hear when {token} items arrive.',

    price: 'Price',
    bid_increment: 'Bid Increment',

    // Items
    more_items_from: 'More Items From: {sellerName}',
    in: 'in',
    by: 'by',
    // Discover Items
    discover_items: "Discover Items You'll Love",
    discover_similar_items: 'Discover Similar Items',
    similar_items_auctioneer: 'Similar items from this auctioneer',
    more_auctions_auctioneer: 'More auctions from this auctioneer',
    discoverPageSuggestions: {
        title: 'Related Searches',
    },
    // Curators
    auction_curated_by: 'Auction Curated By',
    featured: 'Featured',
    featured_lots: 'Featured Lots',

    soldItemCarousel: {
        title: 'Sold on LiveAuctioneers',
        badge: 'Sold',
    },
    soldOnLiveAuctioneers: 'Sold on LiveAuctioneers',

    // Countdown
    day: 'd',
    days: 'DAY',
    hr: 'h', // abrev for Hour
    hrs: 'HR',
    until_auction_starts: 'Until Auction Starts',
    auction_starts_in: 'Auction starts',
    min: 'm',
    mins: 'MIN',
    sec: 's',
    secs: 'SEC',
    left: '{dateFormat} Left',

    // Item Description:
    accepted_payment_methods: 'Accepted payment methods',
    auction_terms_and_info: 'Auction Terms & Info',
    bid_increments: 'Bid Increments',
    condition: 'Condition',
    dimensions: 'Dimensions',
    weight: 'Weight',
    details: 'Details',
    lot_details: 'Lot {lotNumber} Details',
    payment: 'Payment',
    terms: 'Terms',
    shipping: 'Shipping',
    shipping_and_payment: 'Shipping & Payment',

    // Shipping with ARTA
    shipping_with_arta: 'Shipping with ARTA',
    arta_1:
        'LiveAuctioneers has partnered with ARTA to offer an automated shipping solution for auction purchases. This shipping rate is based on the ZIP/postal code provided and includes packing, shipping, and insurance.*',
    arta_2:
        'Small items are delivered by parcel carriers (UPS, DHL) and large items receive quotes for white glove delivery.',
    arta_3:
        'A single shipping rate for all lots won in this auction will be available to book at checkout. Tracking information will be provided by ARTA, with expected delivery within two weeks.',
    arta_4:
        'For any shipping-related questions, please email { email } or see ARTA { privacy }, { standards }, and { terms }.',
    arta_4_email: 'liveauctioneers@shipARTA.com',
    arta_4_privacy: 'Privacy',
    arta_4_standards: 'Standards',
    arta_4_terms: 'Terms',
    arta_5: '*International shipments do not include duties or taxes.',

    // Similar Items
    bid_most_popular_items: 'Other Popular Items',
    bid_on_similar_items: 'Bid on Similar Items',
    // Item Card
    bid: 'Bid',
    // sold_for: 'Sold for',
    sold_for: 'Sold for {amount}',
    lot: 'Lot',
    hide_auctioneer: 'Hide Auctioneer',
    view_full: 'View Full Details',

    // Saved Items
    loading_saved_items: 'Loading Your Saved Items {loaded}/{loading}',
    empty_saved_items_message_part_1: 'Looks like you haven’t saved any items yet.',
    empty_saved_items_message_part_2: 'To save an item, search for items you love, and tap the {heart} icon.',
    empty_saved_items_message_part_3: 'You’ll be alerted when your saved items are coming up at auction. {link}',
    start_your_search_now: 'Start your search now.',

    // Shared
    // AuctionInfo
    ask_a_question: 'Ask a Question',
    followers: '{count} Followers',
    top: 'TOP RATED',
    top_message:
        'This auctioneer consistently excels in accuracy, communication, ease of payment, and shipping quality.',
    top_rated_header: 'Top Rated Auctioneer',
    top_learn_more: 'Learn More',

    // Modals
    // HEALTHCHECK
    healthcheck_dashboard: 'Healthcheck Dashboard',
    refresh: 'Refresh',

    // Install Flash
    enjoy_the_live_auction: 'Enjoy the live auction!',
    having_trouble: 'Having trouble?',
    you_may_need_to_install_flash: 'You may need to install flash.',
    get_adobe_flash: 'Get Adobe Flash',
    we_also_recommend_trying_chrome: 'We also recommend trying Google Chrome.',
    get_google_chrome: 'Get Google Chrome',
    still_having_issues: 'Still having issues?',
    contact_our_support_team: 'Contact our Support Team',
    exit_and_continue_browsing: 'Exit and continue browsing',

    optional_parenthesis: '(optional)',
    country: 'country',
    enter_a_valid: 'Enter a valid {token}.',

    // Sign up
    we_experienced_a_server_error: "Sorry, we've experienced a server error.",
    create_account: 'Create Account',
    show: 'show',
    hide: 'hide',

    // Login
    password: 'Password',
    submit: 'Submit',
    need_an_account: 'Need an account?',
    sign_up_here: 'Sign up here',
    incorrect_password: 'Incorrect password',
    you_must_enter_a_password: 'Please enter a password.',

    // Download Mobile Modals
    bid_live_using_mobile_apps: 'Bid LIVE using our mobile apps',
    enter_the_live_auction_on_our_app: 'Enter the live auction on our free {os} app',
    get_the_free_app_now: 'Get the free app now',
    no_app: "We don't currently have a live bidding app for your device.",
    online_bidding_on_the_go: 'Online bidding, on the go…',
    use_our_apps_to_bid:
        'Use our apps to bid on thousands of antique, fine art, and collectible items from around the world. Preview items in upcoming auctions, place bids in advance, watch and bid on live auctions and more—no matter where you are.',
    treasure_hunt: 'Treasure-hunt like a pro.',
    bid_on_items_added_daily: 'Bid on thousands of items added daily.',

    // Place Bid
    absenteeBidWasRounded: 'Your bid has been rounded to the closest available bid increment.',
    enterCustomBid: 'Enter a custom bid',
    well_send_you_an_email: "We'll send you an email once you've been approved to bid.",
    reserve: 'reserve',
    reserve_not_met_bidder_message: 'Bid Recorded, Reserve not met.',
    reserve_bid_has_been_recorded:
        "Your bid has been recorded, but the reserve hasn't been met. Unless the {reserve} is met, the lot will not be sold.",
    reserve_dispute_popover_text:
        'The reserve is the minimum price the auction house will accept. In order to win, a bidder must meet or exceed the reserve and have the highest bid.',
    confirm_bid: 'Confirm Bid',
    bid_again: 'Bid Again',
    no_thanks: 'No Thanks',
    buyers_premium: "Buyer's Premium",
    premium_info:
        "If you win, you agree to pay a Buyer's Premium of up to {percentage}% and any applicable taxes, duties, and fees as described in this auction's {link}",
    premium_info_no_premium:
        "This auction has no Buyer's Premium! If you win, you agree to pay any applicable taxes, duties, and fees as described in this auction's {link}",
    total: 'Total',
    test_total: 'Total Bid',
    your_maximum_bid: 'Your Maximum Bid',
    test_max_bid: 'Maximum Bid',
    max_bid_popover:
        "What's the most you'll bid to outbid competing bidders? We'll keep your max secret, and bid for you up to this amount.",
    new_maximum_bid: 'New Maximum Bid',
    all_bids_must_be_approved: 'All bids must be approved by the auctioneer.',
    you_have_been_outbid_modal: "You have been outbid by someone else's bid",
    you_can_still_win: 'You can still win. Bid higher.',
    by_clicking_confirm: 'By clicking "Confirm" I agree to this auction\'s {link} and will pay for this item if I win.',
    terms_of_sale: 'Terms of Sale',
    free_shipping_info:
        'This auction offers free shipping to the contiguous US. Ask auctioneer about international & combined shipping rates.',
    flat_shipping_info:
        'This auction offers flat-rate shipping to the contiguous US. Ask auctioneer about international & combined shipping rates.',

    // Retract Bid
    retract: 'Retract',
    retract_bid: 'Retract Bid',
    retract_long:
        'We understand that sometimes things come up; however, retractions are disruptive. LiveAuctioneers may suspend bidders who frequently retract bids.',
    retract_why: 'Why are you retracting your bid?',
    retract_confirm: 'Your bid has been retracted',
    retract_dismiss: 'Back to browsing',
    retract_error: 'Error',

    //  password
    set_new_password: 'Set a new password.',
    set_password: 'SET PASSWORD',
    check_your_email: 'Check your email.',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    please_enter_email_below: 'Please enter your email below.',
    send_reset_password: "We'll send you a link to reset your password.",
    email: 'Email',
    email_address: 'Email Address',
    your_passwords_dont_match: 'Your passwords do not match',
    your_passwords_must_match: 'Passwords must match.',
    your_password_length: 'Your password must be at least 6 characters.',
    your_password_reset: 'Your password has been successfully changed.',
    follow_auctioneer: 'Follow Auctioneer',
    follow: 'Follow',
    following_auctioneer: 'Following Auctioneer',
    following: 'Following',
    back_to_browsing: 'Back To Browsing',
    back_to_bid: 'Back To Bid',
    bid_error:
        "We're sorry, your bid was not successfully placed because of an error we encountered. Please place it again.",

    input_error: 'Input error',
    confirm_changes: 'Confirm Changes',
    confirm_changes_password: 'Please enter your password below to confirm your changes.',
    your_changes_have_been_saved: 'Your changes have been saved.',
    changes_saved: 'Changes Saved',

    // Auction Results
    auction_results_page_title: 'Search Auction Price Results - Live Auctioneers',
    auction_results_page_description:
        'LiveAuctioneers’ Auction Price Results Database is a free research tool for those who want to buy or sell. Access 29 million art, antique, jewelry, furniture, collectible, and fashion results that were auctioned off from thousands of global auction houses.',
    auction_results_description:
        'LiveAuctioneers’ Auction Price Results Database is a free research tool for those who want to buy or sell. Access 29 million art, antique, jewelry, furniture, collectible, and fashion results that were auctioned off from thousands of global auction houses. Search by keyword and refine by auction house, location, origin, style & period, creator, materials, techniques, and more to research and determine the value of items in your existing or future collection. Auction results are updated daily with new hammer prices so you can always access recently sold to historical results dating back to 1999. Whether you’re a collector wanting to know what price to pay; a consignor looking to learn the value of your property; an appraiser or estate office trying to evaluate a client’s possessions; or a journalist researching a given subject, our database is a valuable tool.',
    search_auction_price_results: 'Search Auction Price Results',
    see_auction_price_results_for: 'See {token} Auction Price Results',
    see_upcoming_category_items: 'See Upcoming {token} items',
    price_guide_results_how_much: 'How much is your',
    price_guide_results_worth: 'worth?',
    price_guide_results_value_of: 'Learn the market value of your',
    price_guide_results: 'Prices and Auction Results',
    price_guide_prices: 'Prices',
    price_guide_results_in: 'prices and auction results in',
    price_guide_results_research: 'Research',
    price_guide_title: 'Prices -',
    price_guid_discover: '{token} Prices and Auction Results',
    follow_search_tooltip: 'Follow to get email alerts when new {token} items arrive.',

    // Register
    back: 'Back',
    confirm: 'Confirm',
    register: 'Register',
    pending_approval: 'Pending Approval',
    bid_is_a_contract: 'Your bid is a contract',
    have_a_question_about_terms: 'Have a question about the terms? {askLink}',
    auction_terms_of_sale: 'Auction Terms of Sale',
    terms_and_condtions_of_sale: 'Terms and Conditions of Sale',
    yes_i_agree_to_the_terms: 'Yes, I agree to the terms of sale.',
    notify_me_new_auctions: 'Notify me when {sellerName} lists new auctions.',
    you_must_agree_to_the_terms: 'You must agree to the terms of sale.',
    place_a_bid_only_if_youre_serious: "Place a bid only if you're serious about buying the item.",
    if_you_are_the_successful_and_winning_bidder:
        'If you are the successful and winning bidder, you have entered into a legally binding contract to purchase the property from the seller.',
    you_should_contact_the_seller_to_resolve:
        "You should contact the seller to resolve any questions before bidding.  You can find this option on the item's detail screen.",
    your_auction_registration_is_pending:
        "Your auction registration is pending approval from the auctioneer.  Once you've been approved you'll receive an email from us.",

    // Send Seller Message
    to: 'To',
    subject: 'Subject',
    message_the_auction_house: 'Message the Auction House',
    message_registration_declined:
        'I would like to bid in this auction, but my request to bid was declined. Please let me know how I can get approved to bid.',
    message: 'Message',
    send_message: 'Send Message',
    you_must_enter_a_message: 'You must enter a message.',
    looks_like_something_went_wrong: 'Looks like something went wrong on our end. Please try again.',
    message_sent: 'Your message has been sent',

    // Submit Consignment Modal
    consignment_item_description:
        'Include details like what is it made of, who made it, when, the items condition, included documentations, marks or signatures.',
    item_desc_too_short: 'Your item description should be at least 30 characters',
    image_not_correct_format: 'All images must be .jpg or .png format',
    only_five_images_allowed:
        '5 images is the upload max. The auctioneer will be in contact should they need more photos.',
    why_consign_with: 'Why Consign with {sellerName}?',
    submit_consignment: 'Submit Consignment',
    licensed_auctioneer: 'Licensed auctioneer & expert appraiser',
    reach_millions: 'Reach millions on LiveAuctioneers',
    discover_the_value: 'Discover the value of your item',
    consign_with: 'Consign with {sellerName}',
    click_to_upload: 'Click to Upload Photos',
    item_images: 'Item Images',
    tell_us_about_your_thing: 'Tell us about your item(s)',
    add_photos: 'Add Photos',
    add_photos_description: 'Please submit up to 5 photos. Photos are very important for assessing the value.',
    thank_you: 'Thank You',
    consignment_review_notice:
        '{sellerName} aims to review each and every piece that passes through our inbox. If there is an interest, we may reach out in a few business days',
    keep_browsing: 'Keep Browsing',

    // Seller
    auction_ended: 'Auction Ended',
    ended: 'Ended',
    past: 'Past',
    page: 'page',
    upcoming: 'Upcoming',
    about_auctioneer: 'About Auctioneer',
    ends_sometime_onwards: 'Ends {endTime} {timeZoneAbbr} onwards',
    general_question: 'General Question',
    no_upcoming_auctions: '{auctionHouse} has no upcoming auctions. Follow this auctioneer to hear about new auctions.',
    past_auctions: 'Past Auctions',
    register_to_bid: 'Register To Bid',
    read_less: 'Read Less',
    read_more: 'Read More',
    see_less: 'See Less',
    see_more: 'See More',
    starts: 'Starts {startDate}',
    started: 'Started {startDate}',
    upcoming_auctions: 'Upcoming Auctions',
    upcoming_auctions_from: 'Upcoming Auctions from {name}',
    past_auctions_from: 'Past Auctions from {name}',
    search_upcoming_items: 'Search upcoming items',
    record_results_for: 'Record Auction Results for {name}',
    consign_item: 'Consign Item',
    see_all_price_results: 'See all price results',
    follow_this: 'Follow this',
    follow_updates: 'Follow Updates',
    following_updates: 'Following Updates',
    no_upcoming_auctions_message_not_followed:
        '{name} has no upcoming auctions. {cta} auctioneer to hear about new auctions.',
    no_upcoming_auctions_message_followed:
        "You're following {name}. We'll email you when this auctioneer lists new auctions.",
    why_cant_i_view_the_catalog: "Why can't I view the catalog?",
    this_catalog_is_an_auction_preview:
        'This catalog is an Auction Preview and does not contain any lots. To be updated when it does have lots clicked onto the Follow Catalog Updates button above.',

    // Seller Directory
    auction_house_directory: 'Auction House Directory',
    search_directory: 'Search',
    enter_auction_name: 'Enter Auction House Name:',
    see_upcoming_auctions: 'See Upcoming Auctions Near Me',
    find_auction_houses: 'Find 5,000+ Auction Houses…',
    united_states: 'United States',
    europe: 'Europe',
    all_around_the_world: 'All Around the World',
    near_me_page_title: 'Find Auctions Near Me - Browse Online Auctions Near Me',
    seller_directory_title: 'Auction House Directory',
    loading_auctioneers: 'Loading Auctioneers',
    near_me_page_description: 'Discover auction houses near me.',
    directory_description: 'Find an auction house near me.',

    // Near me page
    loading_auctions: 'Loading Auctions',

    // footer
    footer: {
        recaptcha: {
            privacy: 'Privacy Policy',
            text: 'This site is protected by reCAPTCHA and the Google {tos} and {privacy} apply.',
            tos: 'Terms of Service',
        },
    },

    //reseller checkboxes
    reseller: 'I am a reseller.',

    // mobile
    get_notifications_from_favorite_auctioneers: 'Get notifications from your favorite auctioneers.',
    get_app: 'GET APP',
    pro_tip_track_all_treasures: 'Pro-tip: Track all your treasures with the LiveAuctioneers app.',

    // SEO
    popular_searches: 'Popular Searches',
    artists_and_creators: 'Artists & Creators',
    brands: 'Brands',
    style_periods: 'Style Periods',
    origins: 'Origins',

    // Support
    company: 'Company',
    about: 'About',
    careers: 'Careers',
    press: 'Press',
    auction_central_news: 'Auction Central News',
    support_center: 'Get Help',
    contact_us: 'Contact Us',
    winning: 'Winning',
    how_auctions_work: 'How Auctions Work',
    auction_calendar: 'Auction Calendar',
    trending_auctions: 'Trending Auctions',
    auctions_near_you: 'Auctions Near You',
    auctions_near_me: 'Auctions Near Me',
    past_auction_results: 'Past Auction Results',
    find_auctions: 'Auctions',
    auction_result_search: 'Auction Result Search',
    mobile: 'Mobile',
    selling: 'Selling',
    why_sell: 'Why Sell',
    become_a_seller: 'Become A Seller',
    consign_an_item: 'Consign An Item',
    auctioneer_sign_in: 'Auctioneer Sign In',
    seller_resource_center: 'Seller Resource Center',
    using: 'Using',
    the_new_liveauctioneers_site: 'The New LiveAuctioneers Site',
    classic_site: 'Classic Site',
    copyright: '2002-{year} LiveAuctioneers. All Rights Reserved.',
    ach_terms_and_conditions: 'ACH Terms & Conditions',
    terms_and_conditions: 'Terms & Conditions',
    pr_services: 'PR Services',
    privacy_policy: 'Privacy Policy',
    loading: 'loading…',
    cookie_policy: 'Cookie Policy',

    // Trust
    as_seen_on: 'As Seen On',
    shop_with_confidence: 'Shop With Confidence',
    since_2002_liveauctioneers_has_made_items:
        'Since 2002, LiveAuctioneers has made exceptional items available for safe purchase in secure online auctions.',

    sorry_we_cant_find: "Sorry! We can't find what you're looking for.",

    // Catalog Page
    bannerTitle: '{name}: {title}',
    auction_curator: 'Auction Curator',
    auction_curators: 'Auction Curators',
    search: 'Search',
    sort: 'Sort',
    filter: 'Filter',
    select: 'Select',
    estimate_highest_first: 'Estimate: Highest',
    estimate_lowest_first: 'Estimate: Lowest',
    least_bids: 'Least Bids',
    most_bids: 'Most Bids',
    lot_number_highest_first: 'Lot Number: Highest',
    lot_number_lowest_first: 'Lot Number: Lowest',
    price_highest_first: 'Price: Highest',
    price_lowest_first: 'Price: Lowest',
    date_ascending: 'Date: Ascending',
    date_descending: 'Date: Descending',
    time_ending_furthest: 'Time: Ending Furthest',
    time_soonest_first: 'Time: Starting Soonest',
    saved_recent_first: 'Saved: Recent First',
    saved_oldest_first: 'Saved: Oldest First',
    viewed_recent_first: 'Viewed: Recent First',
    viewed_oldest_first: 'Viewed: Oldest First',
    bid_recent_first: 'Bid: Recent First',
    bid_oldest_first: 'Bid: Oldest First',
    result_recent_first: 'Result: Recent First',
    result_oldest_first: 'Result: Oldest First',
    name_highest_first: 'Name: Z to A',
    name_lowest_first: 'Name: A to Z',
    upcoming_highest_first: 'Upcoming Count: Decending',
    upcoming_lowest_first: 'Upcoming Count: Ascending',
    last_sent_ascending: 'Last Sent: Ascending',
    last_sent_descending: 'Last Sent: Descending',
    recent_item_ascending: 'Item Published: Ascending',
    recent_item_descending: 'Item Published: Descending',
    search_term_ascending: 'Search Term: A-Z',
    search_term_descending: 'Search Term: Z-A',
    current_bid_with_amount: 'Current Bid: {amount}',
    less: 'Less',
    more: 'More',
    lots: 'Lots',
    done: 'Done',
    location: 'Location',
    contact_auctioneer: 'Contact Auctioneer',
    preview: 'Preview',
    view: 'View',
    all: 'All',
    auction_details: 'Auction Details',
    previous: 'Previous',
    next: 'Next',
    approved_to_bid: 'Approved to bid',
    bid_limit_approval: 'Approved to bid up to {limit}',
    you_can_bid_on_any_of_the_items: 'You can bid on any of the items in this auction.',
    try_another_search: 'Please try another search term.',
    results_for: '{count} results for',
    clear: 'Clear',
    loading_results: 'Loading Results…',
    show_all_upcoming_auctions: 'Show all upcoming auctions',
    filter_buy_now: 'Buy Now Only',
    bid_status: 'Bid Status',

    // Add catalog to calendar button
    add_to_calendar: 'Add To Calendar',

    // Search
    you_must_enter_a_min_value_less_than_max: 'Min must be less than the max.',
    you_must_enter_at_lease_one: 'Enter at least a min or max value.',
    you_must_enter_a_valid_zip_code: 'Enter a valid zip code.',
    search_item_count_items: '{count} items',
    search_show_results_for: 'Show results for:',
    searchResultsFor: 'Results for “{searchTerm}”',
    search_see_more: '+ Show More',
    search_see_all: 'Show All',
    search_see_less: '- Show Less',
    search_distance_view_less_countries: 'Show Fewer Countries',
    search_distance_view_all_countries: 'Show All Countries',
    searchChangeCountry: 'Change',
    search_sort: 'SORT:',
    search_no_auction_house_found: 'No auction houses found.',
    search_no_country_found: 'No countries found.',
    search_no_types_found: 'No auction types found.',
    search_no_creator_found: 'No creators found.',
    search_term_for: 'for',
    search_home: 'Home',
    search_see: 'See',
    search_upcoming_item: 'Upcoming Item',
    search_sold_item: 'Sold Item',
    search_results: 'results',
    search_minimum: 'min',
    search_maximum: 'max',
    search_no_results: "No luck! We couldn't find any items matching your criteria.",
    search_no_results_create_alert:
        'to get email alerts when new items matching your criteria are available at auction.',
    search_no_results_saved_alert:
        'Following Search! We will send you email alerts when new items matching your criteria are available at auction.',
    search_error_1: 'Oops! We are having temporary technical difficulties.',
    search_error_2: 'Please try refreshing the page in 10 seconds, or ',
    search_error_contact_support: 'contact our Support Team',
    search_error_3: ' if the problem persists.',
    within: 'Within',
    anywhere: 'Anywhere',
    searchByHousePlaceholder: 'Filter Houses',
    searchByCreatorPlaceholder: 'Filter Creators',

    searchResults: {
        noResultsTitle: '0 Items Found for “{searchTerm}”',
        lookingFor: 'Looking for {suggestion}?',
        relatedTo: 'Related to {searchTerm} Available Now',
        noResultsSubtitle: 'Get Notified when New Items Arrive',
        noResultsSubSubtitle1: 'We’ve listed {count} items matching {searchTerm} on LiveAuctioneers.',
        noResultsSubSubtitle2: 'Follow this search, and we’ll alert you as soon as more arrive.',
        seeAllPriceResults: 'See All Price Results ({count})',
        priceResultsLabel: 'View past sold items for this search.',
        passed: 'Lot Passed',
        similarShelfTitle: 'You May Like',
        sold: 'Sold',
        or: '{suggestionLink} or {houseLink}',
        soldFor: 'Sold: {amount}',
    },

    search_alerts: {
        add_keywords: 'Add Keywords',
        advanced: 'Advanced',
        advanced_search: 'Advanced Search',
        search_followed: 'Search Followed',
        alert_created: "We'll let you know when matching items are listed.",
        new_search_alert: 'New Search Alert',
        follow_search: 'Follow Search',
        placeholder: 'Add a new search term',
        add_another_search: 'Follow another search',
        done: 'done',
        no_followed:
            "You're not following any searches yet! Follow keywords to never miss out on items you're hunting for.",
        sort: {
            newlyListed: 'Newly Listed',
            startingSoonest: 'Time: Starting Soonest',
        },
        resultsFor: '{count} Results for "{search}"',
        resultsPlaceholder: '{count} Lots',
        searchLabel: 'Search:',
        sortLabel: 'Sort:',
    },

    // Upcoming Item Search Sorts
    '-relevance_upcoming': 'Best Match',
    '-popularity_upcoming': 'Most Popular',
    lotNumber_upcoming: 'Lot Number: Lowest',
    '-publishDate_upcoming': 'Newly Listed',
    saleStart_upcoming: 'Time: Starting Soonest',
    '-saleStart_upcoming': 'Time: Starting Furthest',
    '-currentBid_upcoming': 'Price: Highest',
    '-currentBid_sold': 'Price: Highest',
    currentBid_upcoming: 'Price: Lowest',
    '-estimatedPrice_upcoming': 'Estimate: Highest',
    '-estimatedPrice_sold': 'Estimate: Highest',
    estimatedPrice_upcoming: 'Estimate: Lowest',
    '-bidCount_upcoming': 'Most Bids',
    bidCount_upcoming: 'Least Bids',
    '-hammerPrice_upcoming': 'Hammer Price: Lowest',

    // Sold Item Search Sorts
    '-relevance_sold': 'Best Match',
    '-popularity_sold': 'Most Popular',
    '-publishDate_sold': 'Newly Listed',
    saleStart_sold: 'Time: Oldest',
    '-saleStart_sold': 'Time: Newest',
    '-bidCount_sold': 'Most Bids',
    bidCount_sold: 'Least Bids',
    '-hammerPrice_sold': 'Price: Highest',
    hammerPrice_sold: 'Price: Lowest',

    // My Auctions Page
    approved: 'Approved',
    pending: 'Pending',
    auctions: 'Auctions',
    empty_approved_auction_message_part_1: "Looks like you aren't registered to bid in any upcoming auctions.",
    empty_approved_auction_message_part_2: '{link} you love and register to bid in the auctions to win.',
    empty_pending_auction_message_part_1: 'You have no current pending registration approvals.',
    empty_pending_auction_message_part_2: '{link} and register to bid in an upcoming sale.',
    search_for_items: 'Search for items',
    search_for_items_now: 'Search for items now',

    // My bids page
    you_are_leading: "You're Leading",
    reserve_not_met: 'Reserve Not Met',
    outbid: 'Outbid',
    not_approved: 'Not Approved',
    you_won: 'You Won!',
    leading: 'Leading',
    lost: 'Lost',
    increase_bid_of: 'Increase Bid of {bidAmount}',
    increase_max_of: 'Increase Max Bid of {bidAmount}',
    enter_live_auction: 'Enter Live Auction',
    live_bid_starts_in: 'Live Bidding starts in',
    auction_starts: 'Auction Starts In',
    similar_items: 'Similar Items',
    view_similar_items: 'View Similar Items',
    the_item_is_damaged: 'The item is damaged or misrepresented',
    change_of_mind: 'Change of mind',
    found_another_item: 'Found another item',
    other: 'Other',
    please_explain: 'Please explain…',
    loading_my_bids: 'Loading Your Bids {loaded}/{loading}',
    empty_upcoming_bids_message_part_1: 'Looks like you don’t have any bids in upcoming auctions.',
    empty_upcoming_bids_message_part_2: 'Let’s fix that. {link} and start bidding (and winning!)',
    empty_past_bids_message_part_1: 'Bids for items in upcoming or live auctions will be in the Upcoming Tab.',
    empty_past_bids_message_part_2: "After the auction, you'll find the items that you've bid on here.",
    empty_past_bids_message_part_3: 'Head on over to {link} and start bidding (and winning!)',
    search_for_unique_items: 'search for unique items',
    search_for_unique_items_cap_start: 'Search for unique items',

    // Followed auctioneers
    auctioneers: 'Auctioneers',
    upcoming_auct: 'upcoming auctions',
    unfollow: 'unfollow',
    loading_followed_auctioneers: 'Loading Your Followed Auctioneers {loaded}/{loading}',
    fourk_experts: '5,000+ licensed auction experts',
    no_upcoming: 'None',
    follow_any: 'Follow any of our {experts} to access their profile, auctions, and items.',
    click_follow: 'Click the "Follow" button on any auctioneer profile to add them to your list.',
    empty_save_message_part_1: 'Looks like you aren’t following any auction houses.',
    empty_save_message_part_2:
        "You can keep up to date with your favorite auctioneers, by pressing the 'Follow' button on their auctioneer profile page.",
    empty_save_message_part_3: 'Head on over to the {link} to find auctioneers in your area.',

    // Followed searches and alerts
    saved_searches: 'Managed Followed Searches',
    searches: 'Searches',
    never_miss_out:
        'Treasure-hunt like a pro. Thousands of hard-to-find items, unique collectibles and luxury goods are added each day — follow searches and be the first to know when matching items are added.',
    recent_results: 'Recent Results',
    manage_alerts: 'Manage Alerts',
    manage_button_enable_notifications: 'Enable Notifications',
    sent: 'Last new result',
    remove: 'Remove',
    never: 'Never',
    loading_saved_searches: 'Loading Your Followed Searches {loaded}/{loading}',
    loading_saved_search_items: 'Loading Your Followed Search Items {loaded}/{loading}',
    search_page: 'search page',
    empty_recent_results_message_part_1: 'Bummer. There are currently no items that match any of your saved searches.',
    empty_recent_results_message_part_2:
        'Matching items may appear in time. Expand your treasure hunt and {link} to find more interesting items.',
    save_new_searches: 'save new searches',
    unsubscribe_email: '{email} will no longer receive email alerts for "{alert}"',
    unsubscribe_email_already: '{email} is already unsubscribed from email alerts for "{alert}"',
    unfollowSearch: 'Followed search removed.',

    // Category Pages
    follow_category: 'Follow',
    unfollow_category: 'Unfollow',
    following_category: 'Following',
    next_treasure: "Don't Miss Your Next Treasure.",
    no_items_available: 'We have no {title} items available now.  Set up a search alert to hear when it arrives.',
    category_meta_vintage: 'Vintage',
    category_meta_shop_for: 'Shop for vintage',
    category_meta_at_auction: 'at auction',
    category_meta_from: 'from',
    category_meta_for_sale: 'for Sale',
    category_meta_starting_bids: ', starting bids at $1. With over',
    category_meta_antique: 'Antique & ',
    category_meta_lots_available: 'lots available for antique',
    category_meta_and: 'and',
    category_meta_miss_out: "upcoming auctions, you won't want to miss out.",
    category_root_description:
        'Free online bidding auctions available worldwide. Find online auctions for vintage jewelry, artwork, furniture and many other exceptional antiquities.  Available are local auctions online and pick up in-store, or arrange shipping from auctions near you. Thousands of auctions are ending every month, find your treasure.',
    category_root_title: 'Best Online Auctions | Live Auctions - LiveAuctioneers.com',

    // Follow Search
    follow_search: 'FOLLOW SEARCH',
    following_search: 'FOLLOWING SEARCH',
    follow_this_search: 'Follow this search',

    // Search Facets
    search_facet_title_auctionHouse: 'Auction House',
    search_facet_title_F1: 'Categories',
    search_facet_title_F2: 'Origin',
    search_facet_title_countryCode: 'Location',
    search_facet_title_currentBid: 'Current Bid',
    search_facet_title_materialsAndTechniques: 'Material / Technique',
    search_facet_title_stylePeriod: 'Style / Period',
    search_facet_title_creator: 'Creator',
    search_facet_title_estimate: 'Est. Price Range',
    search_facet_title_hammerPrice: 'Sold For',
    search_facet_title_sale_type: 'Buying Format',
    search_facet_title_shipping: 'Shipping',
    search_facet_add_exclusion: 'Exclude',
    search_facet_remove_exclusion: 'Include',
    search_facet_title_topRated: 'House Rating',
    search_facet_title_locationAndShipping: 'Location & Shipping',
    search_facet_title_saleStart: 'Auction Date',
    search_exclude_this_auction_house: 'Exclude auction house',
    search_exclude_auction_house: 'Exclude Auction House',
    search_create_alert: 'Create an alert for this',
    search_see_similar: 'See similar items',
    exclude_house_confirmation:
        'Are you sure you want to exclude {name} from your results and recommendations? You can update this later from their auctioneer profile page or from your search filters.',
    support_message: 'Need help? Visit our {link}',
    seller_exclude_house: 'Exclude this auction house from my searches & recommendations',
    seller_include_house: 'Include in my searches & recommendations',

    searchTerms: 'Search "{searchTerm}"',
    searchTermsDescription: 'Search terms: {terms}',

    // Search Input
    search_input_sold: 'Sold',
    search_input_upcoming: 'Upcoming',
    search_input_search_past_auction_price_results: 'Search auction price results',
    search_input_search_for_items_and_auction_houses: 'Search items and auction houses',

    // Breadcrumbs
    back_to_auction: 'Back to Auction',
    back_to_search: 'Back to Search',
    view_auction: 'View Auction',

    // Item Pages Meta
    item_upcoming_title: 'For Auction: {itemTitle} (#{lotNumber}) on {saleDate} {sellerNameAndLocationString}',
    item_buy_now_title: 'Buy {itemTitle} {sellerNameAndLocationString}',
    item_upcoming_description: ' Lot {lotNumber}, {date}',
    item_buy_now_description: 'Buy Now for {buyNowPrice} or Make An Offer',
    item_sold_description: 'on {saleDate}',
    item_passed_description: 'Item was passed',

    // Storefront Page Meta
    sf_meta_title: 'Jasper52 Seller {sellerId}',
    sf_meta_description: 'Bid and buy expert-vetted {itemCount} items from this trusted Jasper52 seller.',

    // Account Settings Page
    my_profile: 'My Profile',
    profile: 'Profile',
    email_preferences: 'Email Preferences',
    preferences: 'Preferences',
    instant_approval_deposit: 'Instant Approval',
    deposit: 'Deposit',
    change_password: 'Change Password',
    account_update_custom_error: 'Error: {error}',
    account_update_error: "We're sorry, we were unable to update your account at this time. Please try again.",
    newsletters: 'Newsletters',
    frequency: 'Frequency',
    email_alerts: 'Email Alerts',
    for_more_help: 'For more help, ',
    real_time_alerts: 'Real Time Alerts',
    instant_registration_header: 'Instant Registration Deposit',
    deposit_lock_info:
        'When you make a winning bid on an auction your deposit will be locked. You can unlock your deposit by paying your invoice.',
    deposit_locked:
        'Your deposit has been locked because of an outstanding dispute or unpaid invoice on your account. Please clear payment with the auctioneer to have the lock lifted.',
    escrow_transferred_copy: 'Transferred on {created}',
    eth_label: '{amount} ETH',
    confirming_release_copy: 'Confirming your withdrawal',
    confirming_release_label: 'Deposit Released',
    instant_approval_cta_header: 'Get Instant Approval',
    instant_approval_cta_copy: 'Get automatic approval for all auctions by leaving a secure cryptocurrency deposit.',
    instant_approval_cta_link: 'powered by',
    instant_approval_cta_button: 'Get Instant Approval',
    instant_approval_cta_learn_more: 'Learn More',
    unsubscribe_email_preference: '{email} will no longer receive {alert} emails',
    unsubscribe_all_email_preference: '{email} has been opted out of all newsletters',
    unsubscribe_email_already_preference: '{email} is already unsubscribed from {alert} emails',
    unsubscribe_email_dont_recognize: "Sorry we don't understand that subscription code.",

    // Near me page
    find_auctions_near_me: 'Find Auctions Near Me',
    find_auctions_description:
        'Find auctions from thousands of auctioneers near you on an interactive map. Then bid live online on art, antiques, jewelry and collectibles from around the world.',
    find_auctions_on_a_map:
        'Find auctions near an area on a map. Then browse auction catalogs from thousands of auctioneers to bid live online on art, antiques, jewelry, and collectibles.',
    enter_location: 'Enter Location:',
    city_zip_or_postal_code: 'City, ZIP, or Postal Code…',

    // Seller Testimonials page
    seller_testimonials: 'Seller Reviews',
    start_selling: 'start selling',
    consign_items: 'consign items',
    what_our_clients_say: 'What our clients say about us',
    comment1_0:
        '“The New York Times, New York Post, CBS This Morning, The Huffington Post, Associated Press, The Miami Herald, Vogue Italia, Canadian-Latin American-German press agencies, print media and websites-blogs-tweets-Facebook entries worldwide… all writing, tweeting and talking about our January 19, 2013, auction and all because LiveAuctioneers PR Services let the world know about it.',
    comment1_1:
        'The result: our best auction to date, with 690 registered bidders, 568 bids, 186,000 page views, 20,000+ visitors and $330,000 in winning bids, and all that just on LiveAuctioneers.com! That doesn’t include, as a result of your PR work, the record 400+ in-house bidders, phone bidders or left bids that all contributed to a million-dollar auction. The sheer numbers, in terms of sales and bidders, were way beyond our expectations, but you gave us even more, something you can’t pay for… EDITORIAL, exposing our auction house all over the world!',
    comment1_2:
        'You shared our passion about the auction, worked hard (even on nights and weekends) and relentlessly pursued every possible PR lead. We really don’t know how to thank you; you have energized and set the new standard for Palm Beach Modern Auctions.',
    comment1_3:
        'I would recommend your services to any auction house looking to increase their sales or company presence in the auction world.”',
    comment2:
        '“Collectors all over the world really like LiveAuctioneers. The format is simple to use, and it has become a very good highway for bidding in our sales. The age of reservation about bidding online is over; it took a company like LiveAuctioneers, which has proven itself, to make that happen. We have been very pleased.”',
    comment3:
        '“LiveAuctioneers allows us to reach an entirely new audience of potential buyers around the world who can then take part in our auctions ‘live’ on the day. It has had a significant impact on the success of our business.”',
    comment4:
        '“I used to pride myself in having a strong international clientele through phone, mail and fax bidding, but with the addition of LiveAuctioneers, my worldwide client base has increased exponentially. After my last sale, I shipped merchandise to Finland, Denmark, France, Germany, Austria, England, Belgium, the Netherlands, Portugal, Spain, Mexico, New Zealand, Australia, Japan, Canada, Singapore and even to one bidder in Czechoslovakia. It’s amazing that all these people are just a mouse click away.”',
    comment5:
        '“In a nutshell, I wouldn’t be in business without LiveAuctioneers. Our auctions average a 35-40% sell-through with the site, and on many occasions we’ve approached the 50% mark online. LiveAuctioneers has brought us customers from all over the world, including some very good regular buyers in Turkey, Israel and other countries.”',
    comment6:
        '“This last sale was a huge success and the participation through LiveAuctioneers was one of, if not the, highest, so far. It was one of our higher-end sales. We’re seeing a shift in the population that typically bids with us online—a good shift.”',
    comment7:
        '“Online bidding is the staple of any successful auction these days. And having a great online bidding system, like LiveAuctioneers, is critical.”',
    comment8:
        '“Thanks so much for an awesome auction. You all have been a huge part of our business. It seems almost flawless and the bidders seem to find the process so much easier. You all have really built something valuable!”',
    comment9:
        '“Thank you for your help in getting us started. Had it not been for the assistance of your tremendously helpful staff, the auction would not have been the success that it was. Our low estimates were in the $120,000 range, and actual sales were $264,000. Not bad at all!”',
    comment10:
        '“Working with LiveAuctioneers was a fantastic experience for my nonprofit organization. As a public charity, we rely on a variety of means to raise funds. You folks helped us launch our first-ever online auction and it was a tremendous success on a few different levels. First, we exceeded our revenue goals. But perhaps equally important, we did this without eating up a lot of our small staff’s valuable time. The tools that LiveAuctioneers provided us with were invaluable and easy to use. I look forward to working with you again in the future.”',
    comment11:
        '“It’s been a week since our New Year’s auction and we have been struggling to find the right words to describe our first experience with LiveAuctioneers PR Services. Beyond expectations? Incredible? We could not believe the response, not just in the U.S. but around the world. We sold $70,000 to Russian bidders and close to $80,000 to China, in addition to the U.S. and other countries. We were on TV, radio, in newspapers and magazines, on collector sites, the Internet and on top of the search engines. Fabulous! We had over 70,000 hits on LiveAuctioneers, alone, before the auction. Beyond expectations! Just before the auction we took a late consignment and mentioned it to Catherine at LiveAuctioneers. Two days later, it was picked up by major collector sites. Incredible!”',
    comment12:
        '“Just wanted to take the time to tell you that you and your staff are doing a great job! My staff couldn’t be happier with how things are going for us with LiveAuctioneers. The new reports are fabulous. The gentlemen that handle the phones are courteous and oh so patient. Kudos.”',
    comment13_0:
        '“There is no denying that LiveAuctioneers has helped our auction company expand our business. Since we started using their online auction service, our prices have only increased. We have seen thousands of people look at our auctions and have received hundreds of absentee bids, and this is just for one auction! Having several of these auctions has only proved that we are reaching a broader audience than we could have ever imagined.',
    comment13_1:
        'We just held a ‘country store-style’ auction a few weeks ago. Many items sold to online bidders for 2x or 3x the value that we could have gotten here at our auction house. Some items had 30-60 bids; the majority of the bidders were online. It is hard to believe the whole world is watching your auction house, but it is true. For this sale alone, we had hundreds of bidders from all across the U.S. and various countries. Working with LiveAuctioneers has been a great experience. With just a little extra work, our auction company is now known across the world.”',
    comment14:
        '“It’s now the third live auction we have done with LiveAuctioneers, and all we can say is: thank you! Thank you for your professional and fast support, thank you for your effort to improve and adjust your system to the needs of your customers. It’s good to have real people on the phone when you need them and it’s good to get an answer no matter how dull the question. Life would be easier on the web and a better place if there were more companies like LiveAuctioneers.”',
    comment15:
        '“It was an immense pleasure to have LiveAuctioneers help us through our first live auction 5 months ago. They are a benchmark for what excellent support should be.”',
    comment16:
        '“Stout Auctions has used LiveAuctioneers numerous times and we have been exceedingly happy with the results and the service they have offered. One improvement in particular convinced me to write this, and that service is the new invoicing system. No one else has an invoicing system like LiveAuctioneers; it literally saves me a full day of sorting out buyers, shipping costs, emails etc. Keep this up and you’re going to have to buy eBay!”',
    comment17:
        '“I have just been reviewing the new bidder approval process for our current auction. I must say that I am always stunned at how well LiveAuctioneers pioneers this industry we all love. This approval process is ingenious. I am quite sure that a tremendous amount of time and resources were poured into creating this option to assist the auction houses. I am proud to have our auction house as one of your clients. Thank you for breaking down the walls for all us brick & mortar auction galleries who just simply cannot do what you have done, and have done better than anyone else. Continue to educate the world about the joy of auctions and you will always have my support.”',
    comment18:
        '“After using other service providers with online auctions (via eBay and others), we are very pleased with LiveAuctioneers. The service has been great, the back-end administration features are excellent, and the ease of use is appreciated as well. We are most pleased with the post-auction reports and the detailed item reports, allowing us to tweak item descriptions to find the most buyers. We’ll continue to use LiveAuctioneers as our service provider for our online auctions. Thanks!”',
    comment19: '“Your entire company is nothing short of fantastic!“',
    comment20_0:
        '"We handle multiple dozens of specialty properties across the country at any given time – from investment and development land and commercial properties to luxury residences and collectible personal property – and working with a reliable online bidding technology provider has been crucial for us in operating efficiently and delivering value to our clients.',
    comment20_1:
        'From the moment we started working with LiveAuctioneers, we have seen tremendous growth in our personal property sales, and thanks to their expansive bidder audience, incredible client support team, and innovative technology, we can confidently offer the highest level of auction services to our clients."',
    comment21:
        '"Our family auction company recently had the pleasure to work with LiveAuctioneers for the first time. Amidst a jittery public and uncertainty due to COVID-19, we were hesitant to proceed with an online auction since we had conducted mainly on-site, in-person auctions, but LiveAuctioneers reassured us that traffic and sales were increasing exponentially, despite the Pandemic. With their tremendous support, we received targeted webinar training and personalized assistance as we navigated all aspects of their online platform in order to conduct a smooth-running sale: from auction listing to bidder approval, invoices, payments, and their Live-to-eBay program. On March 29th, our Eclectic Designer’s Connecticut Estate Auction debuted online-only, and by far, exceeded our expectations. We are extremely grateful to the entire team for their guidance and expertise. We highly recommend LiveAuctioneers to any auction company transitioning to online-only auctions!"',

    // Privacy Policy Page
    privacyPolicy: {
        title: 'LiveAuctioneers Privacy Policy',
        date: 'Effective as of September 3, 2020',
    },

    // Cookie Policy Page
    cookiePolicy: {
        title: 'LiveAuctioneers Cookie Policy',
        date: 'Effective as of September 3, 2020',
    },

    // Features Page
    features_and_services: 'Features & Services for Auctioneers',
    feature_blurb:
        'Live online auctions deliver a powerful trifecta: the potential of thousands of new customers, increased average hammer prices and dramatically fewer unsold items. Using LiveAuctioneers tools and features, you can track and analyze performance while tapping into the global Internet marketplace to build your business:',
    live_bidding: 'Live Bidding',
    live_bidding_blurb:
        'This allows bidders to place bids at the same time as the auction is actually taking place. The process is similar to telephone bidding, but much faster. Bidders can bid online using their computer, or via iPhone, iPad or Android apps.',
    absentee_bidding: 'Absentee Bidding',
    absentee_bidding_blurb:
        'Once visitors have found an item that interests them, they can leave a bid online. A simple bidding form on the item description page allows them to leave a maximum bid before the sale starts. The bid is recorded and presented to the auctioneer via the live console when the auction starts.',
    auctioneer_dashboard: 'Auctioneer Dashboard',
    auctioneer_dashboard_blurb:
        "The go-to for everything involving a LiveAuctioneers account. From step-by-step auction set-up to bidder registration and approval, it's all organized, along with email messaging, access to marketing services and helpful guides and forms, just a click away.",
    our_network: 'Our Network',
    our_network_blurb:
        'Our live network runs on multiple server clusters located in two different regions of the US to ensure redundancy. Our East Coast and Southern US data centers have fully redundant battery power, generator back-up and massive connectivity, utilizing such reliable network providers as Level 3, Global Crossing and Congent. A team of technologists dedicated to network and server maintenance ensures the reliability of a complex custom system configuration to handle millions of live bidding transactions daily.',
    catalog_set_up: 'Catalog Set-up',
    catalog_set_up_blurb:
        'Item descriptions, images, estimated selling prices and contact details encourage visitors to view your catalogs before registering to bid. After a catalog has been published on LiveAuctioneers, registered bidders can view items and leave absentee bids, or wait to bid live on the day of the sale.',
    bidder_management: 'Bidder Management & Approve, Block, Set as Regular',
    bidder_management_blurb:
        'This feature enables your company to review and approve bidders based on past online activity. It can be done manually or with set criteria, which automatically approves bidders meeting those conditions.',
    inbox_messaging: 'Inbox Messaging',
    inbox_messaging_blurb:
        'This makes communication with bidders easy and centralized, offering you the chance to receive and reply to bidder questions throughout the auction process. All bidder conversations are threaded, linked to bidder profiles, and can be sorted info folders.',
    statistics_tracking: 'Statistics Tracking',
    statistics_tracking_blurb: 'Tracks how many times each item was viewed, number of visitors and referring URLs.',
    self_service_upload: 'Self-Service Upload',
    self_service_upload_blurb:
        'Makes it possible for you to upload images and catalogs directly into the LiveAuctioneers system 24/7.',
    automated_online_console: 'Automated Online Console',
    automated_online_console_blurb:
        'The automated console has the same look and feel of a standard auction, with the key added benefit of running an unmanned online auction, if you prefer.',
    end_of_auction_report: 'End-of-Auction Report',
    end_of_auction_report_blurb:
        'A performance report sent via email with critical statistics: sales totals, visits, hits, bidder registrations and more from a recent auction.',
    live_items_widget: 'Live Items Widget and Live Catalog Widget',
    live_items_widget_blurb:
        'Live Items Widget displays live items directly on the your website in a 220x200 window. Live Catalog Widget displays the entire catalog on your website in the gallery layout.',
    qr_code: 'QR Code',
    qr_code_blurb:
        'A QR code image can be added to your print ads, allowing smart phone users to go directly to your catalog.',
    staff_permission_levels: 'Staff Permission Levels',
    staff_permission_levels_blurb:
        'Permission access levels for your staff can be set within a LiveAuctioneers account.',
    weekly_newsletter: 'Weekly Newsletter',
    weekly_newsletter_blurb: 'This newsletter is sent to bidders weekly, with links to upcoming auctions.',
    help_files: 'Help Files',
    help_files_blurb:
        'This comprehensive tool helps to answer questions about running a sale online, including demo videos and detailed steps.',
    bidder_contact_and_invoicing: 'Bidder Contact and Invoicing',
    bidder_contact_and_invoicing_blurb:
        "This feature enables you to contact winning bidders with customized emails or invoices within minutes of the auction close, avoiding the time-consuming task of invoicing. LiveAuctioneers' fully automated system also allows a buyer to complete his/her purchase online.",
    paypal: 'PayPal',
    paypal_blurb: 'The platform receives automated bidder payment notifications from PayPal.',
    accounting: 'Accounting',
    accounting_blurb: 'This makes it easy to track auction accounting information.',
    white_label_platform: 'White-Label Platform',
    white_label_platform_blurb:
        'This option allows you to customize the live bidding console and run live auctions directly from your website.',
    api_integration: 'API Integration',
    api_integration_blurb:
        "Your auction management software can seamlessly integrate with LiveAuctioneers' database through this function.",

    // How it Works Page
    how_auctions_work_page_title: 'How Auctions Work on LiveAuctioneers',
    how_auctions_work_page_subtitle:
        '<h6>LiveAuctioneers allows you to bid in the world’s best auctions for art, antiques, luxury and collectibles.</h6>{br}Search from hundreds of thousands of items that match what you’re looking for, or simply browse by category and creator to discover one-of-a-kind treasures.  You can place bids in advance, or bid in real-time during the live auction through our website and our { iOS } and { Android } apps. Participating in auctions on LiveAuctioneers just takes a few simple steps:',
    step_one: '1. Create Your Free LiveAuctioneers Account',
    step_one_blurb:
        'Signing up for your free LiveAuctioneers account is easy and secure.  Once you’ve completed your profile on LiveAuctioneers, you can begin participating in online auctions, saving items and following searches. (Note: your information is private and secure.  Any credit card information added to your LiveAuctioneers account will not be shared with auction houses.)',
    step_two: '2. Follow Searches',
    step_two_blurb:
        'Looking for something specific? Type what you’re looking for in the search bar and click ‘Follow Search’ to be notified whenever new items matching your criteria are added to LiveAuctioneers. You can manage your followed searches from your { dashboard } and in the LiveAuctioneers apps for { iOS } and { Android }.',
    step_three: '3. Register for Auctions',
    step_three_blurb:
        'To actively bid in an auction on LiveAuctioneers, you must register first by clicking ‘Register for Auction’ on catalog and item pages.  You may also place absentee bids in advance of the auction time, which doubles as registration requests if you’re not already approved.{br}{br}Most auction houses approve registrations within 24 hours. Every auction house has different criteria for approval, so it’s best to register early in case they require additional information from you. Once approved, any absentee bids you may have placed will be active.',
    step_four: '4. Place Your Bids',
    step_four_blurb:
        'Each auction house handles shipping and payment differently, so before you bid, be sure to review shipping and payment policies to avoid any surprises.  Also be sure to take note of the auction’s live bidding start time. This is when live bidding begins, starting with the first lot in the auction.{br}{br}{br}There are two ways to bid:{br}{br}<h6>Absentee bidding</h6>{br}You can place absentee bids in advance of the live auction.  Our hassle-free absentee bidding system ensures <h6>you get the best prices</h6>. Be sure to submit your maximum bid amount before the live auction begins. Your bid stays at the lowest minimum amount required to keep you in the lead, and increases (up to your max amount) only if another bidder places a competing bid.{br}{br}<h6>Live bidding</h6>{br}Your chances of winning are <h6>three times greater</h6> when you bid during the live auction.  Live auctions begin at the time indicated on catalog and item pages. To bid live, simply visit the catalog or item at the indicated auction time, and click ‘Enter Live Auction’.  You will be taken to the bidding console where the live auction is taking place.{br}{br}Download our 5-star mobile app for { iOS } and { Android } so you can bid anytime, anywhere. Mobile alerts also notify you when your item is coming up for auction so you never miss an important bid.',
    step_five: '5. Win Your Treasure',
    step_five_blurb:
        'You will be automatically notified when you win an item on LiveAuctioneers.  Following the sale, you will be able to make your shipping arrangements, and you will be invoiced by the auction house for your item.  Your credit card information on LiveAuctioneers is never shared, so auction houses who do not accept online payments via LiveAuctioneers may request additional information from you.',
    step_app: 'Treasure Hunt Anytime, Anywhere',
    step_faq: 'Frequently Asked Questions',
    step_faq_descr: 'We’re here to help.  If you need more assistance, visit our full { knowledgeBase }.',

    // How it Works Page Q&A

    question_one_question: 'How do I get approved for an auction?',
    question_one_answer:
        'Each auction house has different criteria for approving bidders for their auctions. Make sure your profile information is complete and accurate; adding a credit card to your LiveAuctioneers account can help speed up the approval process. If you were declined from an auction, contact the auction house by clicking ‘Ask a question’ from the catalog or item page to inquire what additional information is needed to get approved.',
    question_two_question: 'What is a buyer’s premium?',
    question_two_answer:
        'The buyer’s premium is an additional percentage charge that the winning bidder is required to pay.  Buyer’s premiums vary from auction to auction, typically ranging from 0% to 30%. Buyer’s premiums can be found on catalog and item pages',
    question_three_question: 'How does bidding work?',
    question_three_answer:
        'You can place absentee bids in advance of the live auction.  During the live auction, you can place live bids. LiveAuctioneers’ technology prevents you from bidding against yourself, and if someone outbids you prior to the live auction, you’ll be notified via email. Note that auction houses have the ability to limit the total value of bids you’re able to place in a given auction. <learnMore>Learn more</learnMore> about bidding.',
    question_four_question: 'Can I cancel a bid?',
    question_four_answer:
        'Yes. To retract a bid, navigate to <myBids>My Bids</myBids> and select ‘Retract’ to start the retraction process. Do note that absentee bids cannot be retracted less than 2 hours prior to the listed auction start time.',
    question_five_question: 'I’m unsure about the item (authenticity, condition, etc.). What can I do?',
    question_five_answer:
        'If you have any questions regarding an item or an auction, you can contact the auction house by clicking ‘Ask a question’ from the catalog or item page.',
    question_six_question: 'How does communication with an auction house work?',
    question_six_answer:
        'If you have any specific questions regarding an item or a specific auction, you can contact the auctioneer directly through the ‘Ask a Question’ button. Communication is done through LiveAuctioneers’ messaging system, for which you can receive email and mobile notifications whenever you receive new messages. You can manage all your LiveAuctioneers conversations <messages>here</messages>.',
    question_seven_question: 'How do I know if I’ve won an item?',
    question_seven_answer:
        'You will receive an email notification and it will show up on your profile in the <wonItems>Won Items</wonItems> page.',
    question_eight_question: 'How do I pay for the item I won?',
    question_eight_answer:
        'All payment and shipping arrangements are made directly with the auction house. While auction houses typically email you an invoice with payment instructions within 24-48 hours after the end of the auction, you can also contact them directly to follow up on next steps.{br}If an auction house accepts online payments via LiveAuctioneers, invoices will contain a blue ‘Pay Now’ button where you can check out via credit card. Otherwise, you will need to either follow invoice instructions or contact the auction house for payment processing.',
    question_nine_question: 'How does shipping work? ',
    question_nine_answer:
        'As each auction house’s shipping policy may be different, we recommend reviewing the terms and conditions and the shipping policy section of each auction and item page prior to placing bids. While some auctions have their own in-house shipping ability, some may require you to facilitate the shipping process, and others can be pick-up only. If shipping policies are not clear, we encourage you to reach out to the auctioneer directly through the auctioneer’s ‘Ask a Question’ button.',
    question_ten_question: 'What is the return policy?',
    question_ten_answer:
        'Each auction house has their own terms and conditions related refunds and returns, which you can view under the terms and conditions of the auction you wish to participate in. You can also contact the auction house directly through the auctioneer’s ‘Ask a Question’ button.',

    // Price Gateway
    price_gateway_card: 'See Sold Price',

    auction_terminology: 'Auction Terminology',

    intellectual_property: 'Intellectual Property',

    // buyers premium
    middle_low_cut_off: '{middle}% above',
    middle_cut_off: '{middle}% up to',
    high_cut_off: '{high}% above',
    low_cut_off: '{low}% up to',
    low_percentage: '{low}%',

    // banners
    be_a_part_of_the_savviest: 'Be a part of the savviest, smartest group of collectors worldwide',
    hunt_like_a_vintage_shop_owner: 'Hunt like a vintage shop owner',
    join_the_community: 'Join the community',
    start_your_treasure_hunt: 'Start your treasure hunt',
    access_200000_new_items_every_week: 'Access 200,000 new items every week, from anywhere',
    your_next_great_find: 'Your next great find is here',
    get_started: 'Get started',

    lets_go_treasure_hunting: "Let's go treasure-hunting.",
    browse_popular_items: 'Browse popular items',
    find_exceptional_fine_art: 'Find exceptional fine art, collectibles, and décor in online auctions',
    //a/b test
    discover_and_win: "Join the world's best auctions for one-of-a-kind art, antiques & luxury goods.",
    results_database: 'Free Price Results Database',
    discover_exceptional_art: "See what's popular across thousands of items being auctioned daily.",
    around_the_world: 'Find the freshest items from more than 6,000 auction houses across the globe.',
    million_results: 'Access 50 million auction results to find what your items are worth, for free.',

    // won-items
    won: 'Won',
    disputed: 'Open Disputes',
    dispute_status: 'Status',
    disputed_auction: 'Auction',
    disputed_auctions: 'Auctions',
    no_disputes: 'You have no disputed auctions.',
    no_won_auctions: 'You have no won auctions.',
    ask_house: 'Contact Auction House',
    read_review: 'See Your Review',
    leave_review_date: 'Leave a review on {reviewDate}',
    write_review: 'Leave a Review',
    reviewed: 'Rating Submitted',
    make_payment: 'Make A Payment',
    book_shipping: 'Book Shipping',
    view_order_details: 'View Order Details',
    dispute_tooltip_message:
        'A dispute has been filed by the acution house. Please make a payment or contact the auction house to resolve this issue.',

    wonitems: {
        invoice_pending: 'Invoice Pending',
        catalog: {
            total_label: 'Total: {amount}',
        },
        badges: {
            invoice: 'Invoice #{invoiceId}',
            payment_due: 'Payment Due',
            overdue: 'Overdue. {dispute}',
            dispute_filed: 'Dispute filed',
            dispute_resolved: 'Dispute Resolved',
            paid: 'Paid',
            tooltip_message: {
                assume_paid: 'Marked as "Paid" because this invoice is older than 51 days and has no disputes.',
                overdue:
                    'The auction house filed a dispute. Please make a payment or contact the auction house to resolve this issue.',
                resolved: 'The auction house has removed this dispute.',
            },
        },
    },

    explore_collections_from_the_worlds_top: "Explore collections from the world's top auction specialists",
    browse_collectibles: 'Browse collectibles',

    search_auction_results_from: 'Search auction results from 5,000+ auctioneers',
    find_the_perfect_auction_house: 'Find the perfect auction house to sell your items',
    search_price_results: 'Search Price Results',

    // consignments
    consign_items_to_an_auction: 'Consign Items To An Auction',
    why_consign_with_us: 'Why Consign with Us',
    consign_with_trusted_auction_houses: 'Consign with Trusted Auction Houses on LiveAuctioneers',
    how_did_you_aquire: 'How did you acquire this item?',
    how_to_consign_items_to_seller: 'How to Consign Items with {sellerName}',
    consign_description_1:
        "LiveAuctioneers' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help make that key connection to our more than 5,000+ auctioneers.",
    consign_description_1_seller:
        "LiveAuctioneers' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help connect you with {sellerName}.",
    consign_description_2_title: 'Consignment Process:',
    consign_description_2:
        'We assist in the sale of your property by providing a secure, neutral platform in which buyers and sellers worldwide may establish contact. Please complete the online form with item details. Your item will be listed and available for review and evaluation by all auctioneers on our site. If an auctioneer is interested in your item, their staff will get in touch with you.',
    consign_description_2_seller:
        '{title} We assist in the sale of your property by providing a secure, neutral platform in which buyers and sellers worldwide may establish contact. Please complete the online form with item details. Your item will be listed and available for review and evaluation by {sellerName}. If {sellerName} is interested in your item, their staff will get in touch with you.',
    consign_description_3_title: 'Please Note:',
    consign_description_3:
        '{title} Estimates are not provided through this process. If you are seeking an estimate for your item, please contact a local auction house. LiveAuctioneers does not act as an agent for your merchandise, nor do we in any way make representations with respect to the authenticity or value of your material goods.',
    photo: 'Photo',
    value: 'Value',
    i_bought_it: 'I bought it',
    i_inherited_it: 'I inherited it',
    i_found_it: 'I found it',
    it_was_a_gift_it: 'It was a gift',
    log_in_to_consign: 'Log in to consign',
    successfully_submitted: 'Successfully Submitted',
    general_description: 'General Description',
    description: 'Description',
    physical_details: 'Physical Details',
    consignment_submitted: 'Consignment Submitted',
    submit_another_consignment: 'Submit Another Consignment',
    browse_la: 'Browse LiveAuctioneers',
    your_consignment_has_been_submitted:
        'Your consignment has been submitted. If an auctioneer is interested, they will contact you directly.',
    other_help: 'Further information that will help in the sale of your property',
    description_help:
        'Please describe your item an as much details as possible. Please include details like what is it made of, who made it, when, the items condition, included documentations, marks or signatures',
    details_help:
        'Dimensions, manufacturers’ marks, condition (and details regarding any exceptions to condition), material or medium (if artwork), etc.',
    category: 'Category',
    your_item_is_being_shared:
        "Your item is now being shared with 5,000+ of the world's best auction houses.  What happens next? * If an auction house is interested, they'll contact you directly via e-mail.",
    twentieth_century: '20th Century',
    autographs: 'Autographs',
    books: 'Books',
    commercial: 'Commercial',
    decorative_arts: 'Decorative Arts',
    entertainment: 'Entertainment',
    fine_art: 'Fine Art',
    rugs_and_carpets: 'Rugs/Carpets',
    toys: 'Toys',
    please_choose_a_photo: 'Please choose a photo to upload.',
    there_was_an_error_submitting_consignment:
        'We experienced an error trying to submit your consignment.  Please try again later.',

    item_description: 'Item Description',

    ok: 'ok',
    cancel: 'cancel',

    // auction calendar
    auction_date: 'Auction Date',
    select_a_date: 'Select a Date',
    auction_house: 'Auction House',
    auction_status: 'Auction Status',
    auction_calendar_title: 'Auction Calendar - Upcoming Online Auctions & Local Auctions',
    auction_calendar_description:
        'Find all the upcoming online auctions happening today, this week or even months ahead. With over {count} auctions ending today, bid with auctions around the world or local auctions near you.',

    // Today
    today: {
        title: "Today's Trending Auctions",
        description:
            'Find all the upcoming online auctions happening today. With over {count} auctions ending today, bid with auctions around the world or local auctions near you.',
    },

    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Login To Bid',
                signup: 'Signup To Bid',
                register_long: 'Register For Auction',
                pending: 'Registration Pending',
                declined: 'Registration Declined',
                suspended: 'Account Suspended',
                closed: 'Lot Closed',
                sent: 'Your bid has been sent',
                outbid: 'Outbid! Bid {amount}',
                bid: 'Bid {amount}',
                winning: "You're Winning",
                waiting: 'Still waiting on approval?',
                limit_exceeded: 'This item would exceed your bid limit of {limit}',
                approved_limited: "You're approved to bid up to {limit} and have {balance} remaining.",
            },
            conversions: {
                lot_number: 'Lot {lotNumber}',
            },
            description: {
                estimate_range: 'Est. {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                bid_limit_exceeded: 'Your bid limit exceeded',
                competing_bid_amount: '{amount}{converted}: Competing Bid',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    "Competing Bidder was Outbid by Bidder {paddleNumber}'s Absentee Bid",
                last_bid_retracted: 'Last bid of {amount}{converted} retracted',
                limited_approval: 'Approved to bid up to: {limit}',
                liveauctioneers_bid_amount: '{amount}{converted}: LiveAuctioneers Bidder {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    "{amount}{converted}: LiveAuctioneers Bidder {paddleNumber}'s Absentee Bid",
                lot_number_passed: 'Lot {lotNumber} Passed',
                lot_number_reopened: 'Lot {lotNumber} Re-Opened',
                lot_number_skipped: 'Lot {lotNumber} Skipped',
                lot_number_unsold: 'Lot {lotNumber} Unsold',
                lot_opened_asking: 'Lot {lotNumber} Opened - Ask {amount}{converted}',
                lot_sold_competing_bidder: 'Lot {lotNumber} sold for {amount}{converted} to Competing Bidder',
                lot_sold_liveauctioneers_bidder:
                    'Lot {lotNumber} sold for {amount}{converted} to Bidder {paddleNumber}',
                my_bid_amount: '{amount}{converted}: My Bid',
                my_bid_amount_absentee: '{amount}{converted}: My Absentee Bid',
                my_bid_retracted: 'Your bid for {amount}{converted} was retracted',
                paused: 'Auction Paused',
                registration_approved: 'Your registration has been approved',
                reserve_not_met: 'Reserve Not Met',
                you_been_outbid_by_liveauctioneers_absentee:
                    "You've Been Outbid by Bidder {paddleNumber}'s Absentee Bid",
                you_ve_won_lot: "You've won Lot {lotNumber}",
            },
            missives: {
                fair_warning_lot_about_to_close: 'Fair Warning... This lot is about to close',
                going_once_going_twice: 'GOING ONCE...GOING TWICE...',
                third_and_final_warning: 'THIRD AND FINAL WARNING...',
            },
            status: {
                remaining: '{remaining} of {total} Lots Remaining',
            },
            thumbnail_scroller: {
                next: 'Next Lots',
            },
            lockText: {
                locked: 'Unlock to Bid',
                unlocked: 'Bidding Unlocked',
            },
        },
        wait: {
            title: 'Stay tuned. Auction will begin shortly',
            status_message: "{name} is delighted you're here!",
            login_button_text: 'Log In',
            register_button_text: 'Register for Auction',
            image_slider_text: 'Popular Lots in This Auction',
            hidden_text: 'View the Catalog',
            card: {
                title: 'Lot {lotNumber}: {title}',
                bid: 'Bid',
                bids: 'Bids',
            },
        },
        done: {
            title: '{title} has ended',
            status_message: 'Follow {name} to hear about their next auction.',
            live_catalogs_title: 'View Other Live Auctions',
            upcoming_catalogs_title: 'Upcoming Auctions',
        },
    },
    preferredCurrencyConversion: {
        popoverSummary:
            "Please note currency conversions are estimated here based on daily exchange rates which may change before the auction date. Bids and payment will be recorded and remitted in the auction's primary currency.",
        managePreferences: 'Manage Preferences',
    },
    lots_remaining: '{remaining} of {total} Lots Remaining',
    lots_remaining_small: '{remaining} Lots Remaining',
    next_lot: 'Next Lot: {lotNumber}',
    back_to_bidding: 'Back to Bidding',
    go_to_classic_get_it: 'Go classic! Get live video, currency conversion and more language options',
    may_have_to_download_flash: 'You may be required to download Adobe Flash',
    make_classic_my_default: 'Make classic my default for 2 weeks',
    continue_to_classic: 'Continue to classic',
    current_bid: 'Current Bid',
    popular_lots_in_this_auction: 'Popular Lots in This Auction',
    house_is_delighted_your_here: "{name} is delighted you're here!",
    view_the_catalog: 'View the Catalog',
    catalog_will_start_shortly: 'Stay tuned. Auction will begin shortly',
    auction_has_ended: '{title} has ended',
    follow_seller_to_hear_about_their_next_auction: 'Follow {name} to hear about their next auction.',
    lot_number_and_title: 'Lot {lotNumber}: {title}',
    number_and_title: '{lotNumber}: {title}',
    page_number_and_title: ` - Page {page}`,
    view_other_live_auctions: 'View Other Live Auctions',
    you_been_outbid_by_liveauctioneers: "You've Been Outbid by Bidder {paddleNumber}",
    liveauctioneers_bidder_outbid_by_liveauctioneers_absentee:
        "Bidder was Outbid by Bidder {paddleNumber}'s Absentee Bid",
    you_been_outbid_by_competing: "You've Been Outbid by a Competing Bidder",
    ask_price_changed_to: 'Ask Price Changed: {amount}',
    youre_winning: "You're Winning",
    your_bid_has_been_sent: 'Your bid has been sent',
    youve_been_outbid_bid: "You've Been Outbid, Bid {amount}",
    bid_amount: 'Bid {amount}',
    my_bid_submitted: 'My bid for {amount} submitted',
    lot_closed: 'Lot Closed',
    next_lots: 'Next Lots',

    lot_number_closed: 'Lot {lotNumber} Closed',
    placed_bid_on: 'Placed bid of {amount} on {lotNumber}',
    disconnected_from_auction: 'Disconnected from the Auction',
    trying_to_reconnect: 'Trying to reconnect…',

    back_to_top_button: 'BACK TO TOP',

    // catalog ad
    explore_auction: 'Explore Auction',
    your_ad_here: 'Your ad here?',
    advertisement: 'Advertisement',

    // whitelabel header
    return_to: 'Return to {name}',

    // whitelabel footer
    powered_by: '{name} {onlineAuctions} by:',
    onlineAuctions: 'online auctions',
    copyright_whitelabel: 'Ⓒ {year} LiveAuctioneers. {terms} {privacy}',
    privacy: 'Privacy',
    free: 'Free',

    // buy now
    buy_now: 'Buy Now',
    make_an_offer: 'Make An Offer',

    buyNow: {
        buyNowTitle: 'Request to Buy Now',
        makeOfferTitle: 'Make An Offer',
        offerSubtitle: 'Tip: Offers at 75% ({percentage}) and above have the best chance of being accepted.',
        itemPrice: 'Item Price: {price}',
        offerSubmit: 'continue',
        addressSubtitle:
            'This one-of-a-kind item is almost yours! Please confirm your shipping address so we can quote shipping costs.',
        addressSubmit: 'continue',
        formSubtitleShort: 'Our specialists will email {email} within 24 hours to complete your order.',
        formSubtitleLong:
            'Our specialists will email {email} within 24 hours to complete your order. We will include a shipping quote for your approval.',
        formSubmit: 'Submit',
        successSubmit: 'Back to Browsing',
    },

    feedback: {
        contact: 'Contact Us',
        feedback: 'Feedback',
        footer: 'Send Feedback',
        help_us: 'Help Us Improve Your Experience',
        help_you: 'Need immediate help? Visit our {link}.',
        security: 'Learn more about {link} following the recent data security incident.',
        securityLinkTest: 'security improvements',
        securityFollowUp:
            "You may have received a delayed breach notice from your identity monitoring service. Please be advised there's been no additional breach following our June 2020 incident.",
        improve: 'How can we improve this page?',
        email: 'Email Address',
        send: 'Send Feedback',
        link: 'Support Center',
        thanks: 'Thank you. We appreciate your feedback.',
    },

    buy_now_for: 'Buy Now for {price}',

    // Checkout Page
    checkout: {
        errorCodes: {
            DECLINED_EXPIRED: 'Your card has expired, please add a new one.',
            DECLINED_ISSUER: "Your card was declined by your card's issuer, please contact them.",
            DECLINED: 'Your card was declined.',
            INSUFFICIENT_FUNDS: 'Insufficient funds.',
            INVALID_ACCOUNT: 'Card or Account number is invalid, check to make sure this is an up to date card',
            INVALID_ADDRESS: "Billing address doesn't match address on file.",
            INVALID_METHOD: 'Payment method not supported for this house',
            INVALID_SECURITY: 'Security check for this payment failed, check CVV/AVS.',
            UNEXPECTED_ERROR:
                'There was an unexpected error processing your payment, if the problem persists please contact support.',
        },
        back: 'Back to Won Items',
        stepCancel: 'Cancel',
        stepEdit: 'Edit',
        stepError: 'Add',
        page: {
            title: 'LiveAuctioneers Secure Checkout',
            description:
                'Get in on the auction — bid LIVE online on art, antiques, jewelry and collectibles. Find online auctions from around the world at LiveAuctioneers.',
        },
        shipping: {
            title: 'Shipping Address',
            checkbox_label: 'Use my saved address as my Shipping Address',
            save_button_text: 'Save and Continue',
            edit_label: 'Edit',
            cancel_label: 'Cancel',
        },
        shippingMethod: {
            title: 'Shipping Method',
            checkbox_label: 'Use my saved address as my Shipping Address',
            save_button_text: 'Save and Continue',
            edit_label: 'Edit',
            cancel_label: 'Cancel',
            description:
                'LiveAuctioneers partners with ARTA to provide custom packing and shipping services for auction houses and bidders around the world.',
            descriptionList: {
                first: 'Instant shipping quotes',
                second: 'Shipment tracking',
                third: 'Worldwide delivery',
            },
            method: {
                A: '{cost} - Parcel Delivery',
                artaLoading: ' - calculating shipping cost…',
                artaDescription: 'Shipping powered by ARTA.',
                aError: 'Parcel Delivery',
                artaQuoteErrorText: 'Shipping powered by ARTA. Email {mailTo} for final quote.',
                artaEmail: 'liveauctioneers@shiparta.com',
                P: 'Free Local Pick-Up',
                pickupDescription: 'I will pick this up in {location}.',
                self: 'Arrange My Own Shipping',
                selfDescription: 'I will book my own shipping.',
            },
            powered: 'Powered by ',
        },
        payment: {
            acceptAchTerms:
                'I authorize LiveAuctioneers to charge this account for the amount shown, accept the ACH {terms}.',
            addPaymentMethod: 'Add',
            achNotOnFile: 'No Bank on File',
            achOnFile: 'ECHECK (ACH) on File',
            achOnFileDescription: 'Pay with eCheck (ACH) to save ${processingFee} on processing fees.',
            cardNotOnFole: 'No Card on File',
            cardOnFile: 'Card on File',
            cardOnFileDescription: 'Easily pay with a saved credit card on file.',
            title: 'Payment',
            stripe: {
                title: 'Safety & Security',
                description: 'Our Payment provider, Stripe, meets the strictest requirements of PCI-DDS.',
                list_title: 'Your card information…',
                item_1: 'never hits our servers',
                item_2: 'is completely encrypted',
                item_3: 'is never passed to an auctioneer',
            },
            highRisk: {
                editCard: 'Please re-enter your credit card information.',
                editRegulated:
                    'Due to the regulated nature of one or more items in this purchase, we ask that you verify your payment by re-entering your information below.',
                regulatedGoodsTitle: 'Regulated Goods',
                regulatedGoodsText:
                    'Please note that a 4% transaction fee applies to credit or debit card purchases of regulated goods, including alcohol products and certain weapons, like firearms and ammunitions.',
            },
            checkbox_label: 'Use my Shipping Address as my Billing Address',
            edit_label: 'Edit',
            saveButton: 'Save and Continue',
        },
        title: 'Secure Checkout',
        trust: {
            safety: 'Safety & Security',
            pcidds: 'Our Payment provider meets the strictest requirements of PCI-DDS.',
            yourCardInfo: 'Your card information...',
            guarantee1: 'never hits our servers',
            guarantee2: 'is completely encrypted',
            guarantee3: 'is never passed to an auctioneer',
        },
        readOnlyTitle: 'Order Confirmation',
        invoice_summary: {
            title: 'Order Summary',
            loading: 'Loading your invoice…',
            payments_title: 'Payments',
            items_total: 'Items Total',
            buyers_premium: "Buyer's Premium",
            sales_tax: 'Sales Tax',
            processing_fee: 'Processing Fee',
            shipping: 'Shipping',
            tax_popover:
                'Online purchases are subject to sales tax, based on shipping location and state & local rates.',
            tax_exempt: 'Tax-exempt?',
            apply: 'Apply now.',
            apply_tax_exempt: 'Apply Tax-Exempt ID',
            view_tax_exempt: 'View Tax-Exempt Status',
            processing_fee_popover: '4% transaction fee applies to purchases of regulated goods',
        },
        balance: {
            note: 'Note:',
            message:
                "{strong} You'll have the opportunity to arrange shipping with the auctioneer after paying for the item. ",
            shipping:
                'Balance Due does not include ARTA’s {amount} shipping cost. After placing your order, we’ll direct you to ARTA’s website where you can book your shipping.',
            terms: 'By paying for this item, you agree to the {terms} set by the auctioneer.',
            total: 'Balance Due',
            cta: 'Pay Now',
        },
        review: {
            list: {
                first_column_header: '{count} Items',
                first_column_header_singular: '{count} Item',
                second_column_header: 'Price',
            },
            title: 'Review Order',
        },
        total: 'Total',
    },

    // terms banner
    terms_banner: 'By using LiveAuctioneers, you agree to our {tosLink}, {privacyLink}, and {cookieLink}.',

    // Consent modal
    consent: {
        agree: 'Agree',
        you_must_agree: 'You must agree to the terms to continue using the site.',
        privacy_policy_update: 'Privacy Policy Update',
        error: 'We had an error, please try again.',
    },

    // Seller Pages
    seller: {
        empty: 'This seller does not currently have any items for sale.',
        number: 'Seller # {sellerId}',
    },
    catalog_upcoming_description:
        '{lotsListed} lots featured in {catalogTitle} on {date} by {sellerName} in {sellerLocation}',
    catalog_upcoming_description_with_results:
        '{lotsListed} lots featured in {catalogTitle} on {date} by {sellerName} in {sellerLocation}, {coverLotsString} and more.',
    catalog_past_description:
        'See {lotsListed} prices and auction results for {catalogTitle} on {date} by {sellerName} in {sellerLocation}',
    catalog_upcoming_title: 'Bid in {catalogTitle} on {date} by {sellerName} in {sellerLocation}',
    catalog_past_title: '{catalogTitle} Prices - {lotsListed} Auction Price Results - {sellerName} in {sellerLocation}',
    // registration messaging
    registration: {
        sold_auction: {
            approved: 'You were approved to bid in this auction.',
            pending: 'Your request to bid in this auction was pending approval.',
            declined: 'Your request to bid in this auction was declined.',
        },
        contact_auctioneer: 'Contact auctioneer',
        register: 'Register For Auction',
        declined: 'Registration Declined',
        declined_format: 'Contact {houseName} to complete your registration. {link}',
        declined_with_date:
            'Your registration to bid live on {date} was declined. {contactAuctioneer} to get approved.',
        suspended_with_date: 'Your registration to bid live on {date} was declined because your account is suspended.',
        bid_status: '{strong} {extra}',
        outbid: "You've Been Outbid!",
        lot_open: 'This lot is open for bidding!',
        leading_bid: "You're the Leading Bidder!",
        auction_status_pending: 'Your registration to bid live on {date} is pending approval.',
        auction_status_approved: "You're approved to bid live on {date}.",
        auction_status_approved_limited:
            "You're approved to bid up to {limit} and have {balance} remaining for this auction. Bid Live: {date}",
        auction_status_not_registered: 'Get pre-approved to bid live on {date}.',
        raise_bid: 'Raise your bid to increase your chances of winning.',
        leading_after_approval: "If approved, you'll be the leading bidder!",
        pending_raise_bid:
            'Your request to bid is pending approval. In the meantime, raise your bid to increase your chances of winning. {link}',
        pending_raise_bid_tips: 'Tips for Getting Approved',
        reserve_not_met: 'Reserve Not Met',
        reserve_raise_bid: 'Raise your bid to meet the reserve and increase your chances of winning.',
        falls_below: 'Your bid falls below the reserve price for this lot.',
        approved_leading_bid_reserve_not_met:
            "Your bid has been recorded, but the reserve hasn't been met. Unless the reserve is met, the lot will not be sold.",
        issue: 'Issue with Auction Registration on {catalogTitle}',
        payment_issue: 'Question from winning bidder (Lot {lotNumber})',
        request_submitted: 'Request To Bid Submitted',
        preview_only: 'Preview only',
        closing_today: 'Lot Closes Today',
        preview_only_description: 'This catalog is only available for preview on LiveAuctioneers.',
        preview_only_description_short:
            'This catalog is only available for preview on LiveAuctioneers. Request online bidding to notify the auction house of your interest in bidding on LiveAuctioneers.',
        lot_closed: 'Lot Closed',
        lot_won: 'You Won This lot!',
        lot_won_copy:
            'Expect an email invoice from {houseName} within 3 business days. {link} with any questions regarding payment.',
        lot_lost_copy: "Someone else placed an earlier or higher bid, or your bid wasn't approved. {link}",
        tips_for_winning: 'Tips For Winning Next Time',
        contact_this_auctioneer: 'Contact this auctioneer',
        lot_lost: 'Sorry, your bid lost.',
        no_longer_bid: 'You can no longer bid on this lot.',
        liveMessages: {
            pending: 'Live bidding started at {today}. Your registration to bid is pending approval.',
            approved: "Live bidding started at {today}. You're approved to bid in this auction.",
            limited:
                'Live bidding started at {today}. You’re approved to bid up to {limit} and have {balance} remaining for this auction.',
            declined:
                'Live bidding started at {today}. Your request to bid was declined. {contactAuctioneer} to get approved.',
            suspended:
                'Live bidding started at {today}. Your registration to bid was declined because your account is suspended.',
            notRegistered: 'Live bidding started at {today}. Get approved to bid. {register}',
            yesterday: '{time} yesterday',
            today: '{time} today',
        },
    },

    // save item button
    bidders_saved_item: '{savedCount} bidders watching this item',
    bidder_saved_item: '{savedCount} bidder watching this item',

    watch_live_auction: 'Watch live auction',
    items_until_this: '{count} lots until this item is up for sale.',
    currently_up_for_bid: 'This item is currently up for sale',
    suspendedBidderBanner: {
        button: 'Restore Bidding',
        text: 'Action Needed: Bidding privileges are suspended.',
    },
    followedSearchCarousel: {
        header: 'New From Followed Searches',
        viewAll: 'See All',
    },
    searchFollowSuggestions: {
        altHeader: 'Popular Searches',
        header: 'Searches To Follow',
        manage: 'Learn More',
        subTitle: 'Be the first to hear about new items you love.',
        follow: 'Follow',
        items: 'items,',
        followers: 'followers',
    },

    featuredCatalogCarousel: {
        header: 'Featured Auctions',
        viewAll: 'See All',
    },

    recently_viewed: 'You Recently Viewed',
    recommended_items: 'Recommended Items',
    coming_up_title: 'Coming Up For Auction',
    preprod_warning_banner_text:
        'Warning: This environment is pointed to production data. Changes here affect real auctions.',
    registration_status_label: {
        request_online_bidding: 'Request online auction',
        register_for_auction: 'Register for Auction',
        registration_pending: 'Registration Pending',
        catalog_only_registration_submitted: 'Bid Request Submitted',
        registration_approved: 'Approved To Bid',
        registration_declined: 'Registration Declined',
        request_submitted: 'Request Submitted',
    },
    review_page: {
        review_your_auction: 'Rate Your Experience',
        received_items: 'Have you received your items?',
        received_item: 'Have you received your item?',
        encourage_wait:
            'We encourage you to rate your experience after receiving your items. This gives you a chance to rate shipping and item accuracy.',
        waiting_for_items:
            "If you haven't received your items and haven't heard from {name}, {sendMessage}, or {contactSupport} for help.",
        continue: 'Continue Review',
        later: 'Finish Later',
        send_message: 'send a message',
        contact_support: 'contact our Support Team',
        great: 'Great! ',
        tell_us: 'Tell us about your experience with {houseName} below:',
        yes: 'yes',
        no: 'no',
        na: 'N/A',
        headline_placeholder: "What's most important to know?",
        input_length_error: 'Please enter at most {limit} characters.',
        public_review: 'Write a public review for {houseName}',
        private_feedback: 'Send feedback privately (optional)',
        rated_date: 'You rated {name} on {date}:',
        error: 'Unable to process your review at this time',
        review_guidelines: {
            header: 'Public Review Guidelines',
            body:
                'Your review may appear publicly alongside your city and first name. We may not publish your review if it includes personal or inappropriate content such as:',
            lastNames: 'Last names',
            addresses: 'Addresses',
            phoneNumbers: 'Phone numbers',
            email: 'Email addresses',
            trackingNumbers: 'Tracking numbers',
            profanity: 'Profanity',
            link: 'Read more review guidelines',
            mobileBody:
                'We may not publish your review if it includes personal or inappropriate content, such as: last names, addresses, phone numbers, emails, tracking numbers, or profanity.',
        },
        character_requirements: '{remaining} characters remaining.',
        fields: {
            accuracy: 'Accuracy',
            responsiveness: 'Responsiveness',
            payment: 'Payment',
            shipping: 'Shipping / Pick-Up',
            overall: 'Overall Experience',
            feedback: 'Private Feedback for the Auction House',
            review: 'Write a Public Review',
        },
        field_detail: {
            accuracy: 'How satisfied were you with the accuracy of photos and descriptions provided by {houseName}?',
            responsiveness_1: 'Did you contact {houseName} with a question or concern?',
            responsiveness_2: 'How helpful was {houseName} in responding to your questions or concerns?',
            payment: 'How satisfied were you with the payment process?',
            shipping: 'How satisfied were you shipping or pick-up process?',
            overall: 'Overall, how satisfied were you with your experience with {houseName}?',
            feedback: 'Is there anything else you would like {houseName} to know about your experience with them?',
            review: 'Is there anything you would like other bidders to know about your experience with {houseName}?',
        },
        labels: {
            headline: 'Headline',
            public_review: 'Public Review',
            private_feedback: 'Private Feedback for the Auction House',
            private_feedback_label: 'Private Feedback',
        },
        review_copy: {
            _1: 'Very Dissatisfied',
            _2: 'Somewhat Dissatisfied',
            _3: 'Neutral',
            _4: 'Somewhat Satisfied',
            _5: 'Very Satisfied',
        },
    },
    disabled_would_exceed: 'This item would exceed your bid limit of {limit}',
    //notifications
    notifications: {
        enable_browser_notifications: 'Enable Browser Notifications',
        enable_notifications: 'Enable Browser Notifications',
        enable_notifications_message:
            'Treasure-hunt like a pro.  Enable desktop notifications to stay updated on important items and auctions.',
        enable_desktop_notifications: 'Enable Desktop Notifications',
        get_notifications_browser: 'Browser notifications are off.',
        get_notifications_phone: 'Get notifications on your phone.',
        download_app: 'Download App',
        no_new_notifications: 'All caught up!',
        modify_your_browser_preferences:
            'Modify your browser preferences to proceed with enabling browser notifications.',
        notifications_enabled: 'Browser notifications are on.',
        notifications_denied:
            "You've disallowed notifications in your browser.  Access your browser preferences to allow notifications.",
        delete_all: 'Clear All Notifications',
        outbid_notify: "Notify me when I'm outbid",
        just_now: 'Just now',
        get_notifications_when_outbid:
            'Stay in the lead. Get notifications on this device for all your bids, favorite lots, and sellers.',
        turn_off_notifications: 'Disable Browser Notifications',
        enable_notifications_prompt_title: 'Never miss a treasure!',
        enable_notifications_prompt_body:
            'Enable browser notifications and get updates on important items and auctions?',
        yes: 'Yes, Update Me',
        risk_it: 'No',
        get_notified:
            'Get SMS and browser notifications when you’re outbid and when your item is coming up for auction.',
    },

    // personalize banner
    personalizeBanner: {
        title: 'What are you hunting for?',
        subtitle: 'Personalize your homepage recommendations',
        subtitle_short: 'Personalize your homepage',
        cta: 'Go',
    },

    // user menu
    userMenu: {
        notifications: 'Notifications',
        favorites: 'Favorites',
        my_bids: 'My Bids',
        my_account: 'My Account',
        greeting: 'Hi, {firstName}',
    },
    review: {
        learnMoreHere: 'Learn more here',
        bidder_reviews: 'Bidder Reviews',
        bidder_reviews_name: 'Bidder Reviews for {name}',
        review_count: '{count} Reviews',
        review_count_singular: '{count} Review',
        latest_review: '1 Latest Review',
        latest_reviews: '{count} Latest Reviews',
        full_page_review_title: '{start}-{end} of {count} Reviews',
        helpful: 'Helpful',
        report: 'Report',
        reported: 'Reported',
        report_abuse_title: 'Report Abuse',
        report_abuse_body:
            'If this review is inappropriate and should not be shown on Liveauctioneers.com, let us know by submitting a report.',
        report_abuse_button: 'REPORT',
        report_submitted_title: 'Thank you!',
        report_submitted_body:
            'We’ve received your report and our team will investigate this review. Thanks for helping keep LiveAuctioneers a safe and friendly space.',
        report_submitted_button: 'DONE',
        no_reviews: 'No reviews yet',
        overall_rating_label: '{rating} out of 5.0 Stars',
        reviews_coming_soon_header: 'Coming Soon',
        reviews_coming_soon_line1: 'See what bidders are saying about {name}.',
        reviews_coming_soon_line2: 'Reviews left by winning bidders will be displayed here soon.',
        all_reviews: 'Reviews',
        verified_buyer_headline: 'Verified Buyer',
        verified_buyer_text: 'This review is written by a verified LiveAuctioneers winner.',
        page_link_button: 'See all {count} reviews',
        page_link_button_singular: 'See 1 review',
        meta: {
            title: '{houseName}, {houseLocation} - Read over {reviewsCount} Reviews from Customers',
            description: '{reviewsCount} real customer reviews of {houseName}, {houseLocation} "{reviewSnippet}"',
        },
        see_all: 'See All',
        not_enough_data: 'Not enough data',
        ratings_explanation:
            'LiveAuctioneers calculates star ratings based on ratings given, number of reviews, age of reviews, and only accepts reviews from winning bidders.',
    },
    ranking: {
        accName: 'Accurate Descriptions',
        accPopoverHeader: 'Top Rated in Accuracy',
        accPopoverText: 'This auctioneer excels at providing descriptions and photos that represent items accurately.',
        respName: 'Quick Responses',
        respPopoverHeader: 'Top Rated in Responsiveness',
        respPopoverText: 'This auctioneer excels at responding to customer inquiries in a helpful manner.',
        payName: 'Easy Payments',
        payPopoverHeader: 'Top Rated in Payments',
        payPopoverText: 'This auctioneer excels at providing customers a way to easily pay for items.',
        shipName: 'Seamless Shipping',
        shipPopoverHeader: 'Top Rated in Shipping',
        shipPopoverText: 'This auctioneer excels in offering a seamless shipping experience.',
    },
    stars: {
        one: '1 Star',
        two: '2 Star',
        three: '3 Star',
        four: '4 Star',
        five: '5 Star',
    },
    sellerPageTabLinks: {
        auctions: 'Auctions',
        upcoming: 'Upcoming Auctions',
        news: 'News',
        past: 'Past Auctions',
        reviews: 'Reviews',
        results: 'Record Results',
    },

    // codex service
    codex: {
        addAll: 'Add All (Last 365 Days)',
        checkoutCopy:
            'Claim a secure digital provenance certificate by visiting your Won Items page within 365 days of payment.',
        claimCodexRecords: 'Claim {count} Codex Records',
        claimProvenance: 'Claim Provenance Certificate',
        claimCopy:
            'LiveAuctioneers has partnered with Codex to offer digital provenance certificates. You can claim free Codex Records for your last 365 days of won items.',
        clearAll: 'Clear All',
        clickHere: 'click here',
        copied: 'Copied',
        copyLink: 'Copy Link',
        learnMore: 'Learn More',
        receiveConfirmationEmail: 'You will also receive a confirmation email with your Codex link.',
        recordLinkCopy: "Finish claiming your records on Codex's website. Please {link} if a new window does not open.",
        selected: 'Selected:',
        selectedForCodex: 'Selected For Codex',
        someItemsNotSubmitted: 'Some items not submitted because you submitted them before.',
        submissionConfirmed: 'Submission Confirmed',
        submissionError: 'Submission Error',
        whatIsCodex: 'What is Codex?',
        youHaveAlreadySubmitted: 'You have already submitted all items.',
    },

    // autopay
    autopay: {
        absenteeBidModal:
            '{sellerName} uses Autopay by LiveAuctioneers! Autopay makes purchasing on LiveAuctioneers even easier. Click {link} to learn more.',
        modalLink: 'here',
        addPayment:
            'This auction uses Autopay by LiveAuctioneers. If you place a winning bid, we will charge your credit card automatically three days after you receive an invoice for your item.',
        terms: {
            heading: 'About Autopay by LiveAuctioneers',
            body:
                "When you have a credit card on file with LiveAuctioneers, Autopay will automatically charge that card so that you don't need to check out. If you want to pay with an alternative payment method, contact the auction house directly to let them know. Otherwise, your card on file will be charged three days after your invoice is sent.",
        },
    },
    messaging: {
        title: 'Messages',
        inbox: 'Inbox',
        delete: 'Delete',
        sent: 'Sent',
        trash: 'Trash',
        folders: 'Folders',
        move: 'Move to Folder',
        markUnread: 'Mark Unread',
        markRead: 'Mark Read',
        unread: 'Unread',
        archive: 'Archive',
        show_more: 'Show More',
        show_less: 'Show Less',
        new_folder: 'New folder name',
        edit: 'Edit',
        new: 'New',
        cancel: 'Cancel',
        yes: 'Yes',
        paging: '{firstNumber}-{secondNumber} of {totalRecords}',
        item: 'Item',
        current: 'Current: ',
        maxBid: 'Your Max Bid: ',
        sold_for: 'Sold for',
    },
    billingAddress: {
        billingAddressTitle: 'Credit Card Billing Address',
        updateBillingAddress:
            'To verify your credit card on file, please enter the billing address associated with the credit card ending in {last4}',
    },

    FormattedMessageTextTest:
        'This is a message{br}<caption>caption</caption><h1>h1</h1><h2>h2</h2><h3>h3</h3><h4>h4</h4><h5>h5</h5><h6>h6</h6><mini>mini</mini><primary>primary</primary><secondary>secondary</secondary>',

    certManagement: {
        taxes: 'Tax Exemption',
        certificates: 'Certificates',
        state: 'State',
        signedDate: 'Date Signed',
        expirationDate: 'Expiration Date',
        status: 'Status',
        view: 'View',
        renew: 'Renew',
        delete: 'Delete',
        addCert: 'Add New Certificate',
        upload: 'Add Certificate',
        selectState: 'In which state are you tax-exempt?',
        taxCerts: 'Tax Exemption Certificates',
        uploadYourTaxInfo: 'Add New Certificate',
        backToTaxManagement: 'Back to Tax Management',
        manageCerts: 'Add, delete, and manage your tax exemption certificates.',
        valid: 'Valid',
        invalid: 'Invalid',
        inReview: 'In Review',
        reviewingCertificate: "We're reviewing your tax-exempt certificate.",
        invalidCertificate: 'This certificate is invalid. Please upload a new one.',
        missingCertToken: 'There has been a problem.  Please try again later',
    },

    loadMore: 'Load More',
    discoverPage: {
        meta: {
            descriptionMultipleCategories:
                'Hunt for antique & vintage {term} {l1First} and {l1Second}. {totalRecords} {term} items for online auction.',
            description: 'Hunt for antique & vintage {term} {l1First}. {totalRecords} {term} items for online auction.',
        },
        buttons: {
            shipping: 'Easy Shipping',
            us: 'US Only',
            new: 'Newly Listed',
            top: 'Top Rated House',
        },
    },
};
